import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  ...enLocale,
  // 提示
  message: {
    welcome: 'welcome',
    tip: 'Tip',
    loginFailed: 'Account or password error.',
    signOut: 'Are you sure to quit?',
    removeBrandTip: 'Are you sure to remove the brand?',
    removeProductTip: 'Are you sure to remove the product?',
    removeFormulaTip: 'Are you sure to remove the formulation?',
    removeIngredientTip: 'Are you sure to remove the ingredient?',
    enableTip: 'Are you sure to enable it?',
    disableTip: 'Are you sure to disable it?',
    contactName: 'Contact Name cannot be empty!',
    email: 'Email cannot be empty!',
    validEmail: 'Please enter a valid email address!',
    company: 'Company Name cannot be empty!',
    address: 'Address cannot be empty!',
    submitOrder: 'Are you sure to submit your order?',
    addSuccess: 'Add success.',
    saveSuccess: 'Save success',
    sendSuccess: 'Send success',
    success: 'Success',
    fail: 'Fail',
    emptyFile: 'No file selected',
    deleteSuccess: 'Delete success.',
    comparisonExists: 'The comparison already exists.',
    score: 'Please score',
    comments: 'Please enter comments',
    successFeedback: 'Successful submission of feedback',
    failureFeedback: 'Failure to submit feedback',
    successSupport: 'Successful submission of technical support',
    failureSupport: 'Failure to submit technical support',
    passwordEmpty: 'Password cannot be empty',
    newPasswordEmpty: 'New Password cannot be empty',
    ConfirmPasswordEmpty: 'Confirm Password cannot be empty',
    samePassword: 'Can\'t be the same as the old password',
    passwordDifferent: 'New passwords are different',
    successPassword: 'change password success',
    passwordEror: 'Primitive password error',
    denyNeeded: 'Deny reason needed',
    weightNotAvailable: 'Weight Not Available',
    required: 'required',
    fileMaxSize: 'size is limited to', // eg. document size is limited to 20M
    emptyMessage: 'Reply required',
    sureSubmit: 'Confirm the content submitted for editing?',
    noPermission: "Can't view this module, please ask for customer service for more authority",
    selectOne: 'Select at least one',
    codeEmpty: 'Verification code cannot be empty',
    emailEmpty: 'E-mail cannot be empty',
    frequentlyTips: 'Your access is too frequently, please compete verification first.',
    updatePasswordTip: {
      title: 'Reminder: Change your password',
      content: 'In order to protect your account, please regularly update your password. Accounts would be locked if password is not changed for 5 months.<p>Last password changed time : <span style="color: #FF6600">{current}</span></p>',
      noPassRecord: 'No record of changing password'
    },
    accountLockTip: {
      title: 'Alert: Account locked',
      content: 'Your password has not been changed for 5 months, your account is locked. Please change your password now in order to log into the system.'
    },
    noLoginTip: {
      title: 'Alert: Account disabled',
      content: 'Since you have not logged into the system for 6 months, your account has been disabled. Please contact DlitE3X Admin for account re-activation.',
      tips: 'System has received your application, please wait for processing',
      message: 'Requests are too frequent. Please try again later.'
    },
    passwordErrorTip: {
      title: 'Alert:  Account temporary locked for 30 minutes',
      content: 'You have entered the wrong password for more than 5 times and your account is temporarily locked. Please try to log in again after 30 minutes.'
    },
    loginDenied: {
      title: 'Login denied!',
      content: 'You are already logged in on a different device. Please log out of the other device and try again OR contact the technical support by {current} Thank  you.'
    },
    resetPwd: {
      title: 'Login denied!',
      content: 'Password has been reset, please log in again'
    },
    noPermissionTip: {
      title: 'Tips',
      content: 'Access denied, please contact admin for more authority if necessary.'
    },
    loginTimeout: 'Login Timeout',
    reLoginTips: 'Your session has expired, please re-login',
    type: 'Please select type',
    passwordEasy: 'Your password must be between 8 and 30 characters; contain at least two conditions in numbers, letters, and special characters',
    passwordAgain: 'Please enter the passwords again',
    passwordInput: 'Please enter the passwords',
    passwordNotMatch: 'The passwords entered did not match',
    emailRequired: 'Account(E-mail) is required',
    emailError: 'Illegal Account(E-mail) address',
    domainError: 'Illegal Domain mail',
    uploadHeadImg: '* Only JPG/JPEG for avatar is supported. Size < 2mb',
    exportTips: 'In this module, you can only download no more than 300 records in last 24 hours.',
    inciNotInclude: 'This ingredient is not included yet.',
    changePwdSuccess: 'Password has been changed, please log in again',
    verificationCodeRequired: 'Your verification code must be 6 characters',
    goBack: 'Back',
    dataNotFound: 'Data not found',
    noAccess: 'Sorry, you have no access to detail',
    moreThanOneYear: 'The maximum selectable time frame is one year. <br> The selected time frame exceeds the maximum limit, please select again.',
    permissionChanged: 'Permission has been changed,Please refresh page to obtain latest permission',
    changedNoPermission: 'Permission have been changed，Access denied，Please log out',
    tips: 'Tips',
    conceptUploadFileTips: 'Only MP4 for video and PDF for documents is supported. MP4 < 50mb, PDF < 20mb',
    uploadImgTips: 'Only png、jpg、jpeg、bmp for format is supported，Size <10mb',
    uploadVideoTips: 'Only MP4 for video is supported. MP4 < 50mb',
    uploadPPTTips: 'Only PPT for documents is supported. PPT < 20mb',
    uploadPDFTips: 'Only PDF for documents is supported. PDF < 20mb',
    uploadWatermarkTips: 'Upload successful，But PDF is encrypted and cannot generate watermark',
    cookiesTis: 'Cookies help us deliver our services. By using our services, you agree to our use of cookies.',
    learnMore: 'Learn more',
    items: 'Items',
    downloadQuota: 'You have exceeded the maximum daily download quota. Please contact Admin or try again later. Thank you.',
    deleteDraftTips: 'Are you sure to delete this draft?',
    operateFail: 'operate fail'
  },
  txt: {
    formulationComment: 'Comment',
    messageCenter: 'Message Center',
    desc: 'desc',
    asc: 'asc',
    noData: 'No Data.',
    noFound: 'No Found',
    country: 'Country',
    china: 'China',
    other: 'Other',
    language: 'Language',
    new: 'New',
    hot: 'Hot',
    yes: 'Yes',
    no: 'No',
    moreThan10000: 'show 10,000 records if the total record more than 10,000.',
    // dataSource1: '*Data source: Euromonitor',
    // dataSource2: '*Data source: Beauty Evolution',
    dataSource1: '',
    dataSource2: '',
    currentPriceBased1: 'Current price based: 2021 fixed exchange rate.',
    currentPriceBased2: 'Current price based: 2019 fixed exchange rate. 2019-2023 data is forecast data',
    pricePosition: '*The price position are based on all brand product price.',
    relatedClicks: 'All data related to clicks start from April 2018.',
    advancedSearch: 'Advanced Search',
    brand: 'Brand',
    product: 'Product',
    formulation: 'Formulation',
    claims: 'Claims',
    claim: 'Claim',
    similarClaim: 'Similar Claim',
    total: 'Total',
    total2: 'Total: ',
    records: 'records',
    sortBy: 'Sort by',
    releaseYear: 'Release Year',
    functionClaim: 'Functional Claim',
    year: 'Year',
    date: 'Date',
    segment: 'Segment',
    subSegment: 'Sub-segment',
    marketSegment: 'Market Segment',
    category: 'Category',
    productName: 'Product name',
    categories: 'Categories',
    click: 'Click',
    writeComment: 'Write your comment',
    favorite: 'Favorite',
    commentScore: 'Comment Score',
    comment: 'Comment',
    comments: 'Comment',
    commentTarget: 'Comment Target',
    commentTime: 'Comment Time',
    expertComment: 'Expert Comment',
    Level1commentId: 'Level 1 comment id',
    claimsForm: 'Claims/Form',
    claimsSubCategory: 'Claims/Sub-category',
    retailPrice: 'Retail price',
    insertPriceRange: 'Insert Price Range',
    currency: 'Currency',
    searchFor: 'Search for',
    brandDiscription: 'Brand Description',
    productDescription: 'Product Description',
    ingredients: 'Ingredients',
    similarBASFFormulations: 'Similar formulation & product',
    lucklySimilar: 'Lucky we got some very similar formulations for you:',
    heyInteresting: 'Lucky we got some very similar formulations for you:',
    noFoundSimilar: 'Nothing found for you, why don’t we create a new one?',
    tabBasfProduct: 'Hey, found something interesting for you:',
    noFoundBasfProduct: 'Nothing found for you now!',
    lucklyRelated: 'Lucky we got some very related formulations for you:',
    lucklyProducts: 'Lucky we got some very similar BASF products for you:',
    consumerInsight: 'Consumer insight',
    mayBeInterested: 'You may be interested in',
    INCLUDEDTradename: 'INCLUDED Tradename',
    INCLUDEDINCI: 'INCLUDED INCI',
    EXCLUDEDTradename: 'EXCLUDED Tradename',
    EXCLUDEDINCI: 'EXCLUDED INCI',
    INCLUDEDIngredients: 'INCLUDED Ingredients',
    EXCLUDEDIngredients: 'EXCLUDED Ingredients',
    tags: 'Tags',
    title: 'Title',
    normalTitle: 'Title',
    formulationID: 'Formulation ID',
    releaseRegion: 'Release Region',
    phase: 'Phase',
    ecoStatus: 'Eco Status',
    byWeight: '% by Weight',
    function: 'Function',
    specifications: 'Specifications',
    performance: 'Performance',
    manufacturingProcess: 'Manufacturing Process',
    whatThink: 'Tell me what you think',
    noComment: 'No comment',
    ingredient: 'Ingredient',
    tradeName: 'BASF Product',
    ingredientName: 'Ingredient Name',
    CASNumber: 'CAS Number',
    registrationCountry: 'Release Locations',
    ingredientsAplicationAnalysis: 'Ingredients application analysis',
    moreInformation: 'More Information',
    ingredientCombination: 'Ingredient combination',
    functionCombination: 'Function after combination',
    relatedIngredient: 'Related Ingredient',
    relatedFormulation: 'Related Formulation',
    similarProduct: 'Similar BASF Products',
    percentageCorrelationRatio: 'Percentage means the correlation ratio',
    combinationRate: 'Combination Rate',
    productInformation: 'Product Information',
    brandInformation: 'Brand Information',
    selectAll: 'Select All',
    basicInformation: 'Basic Information',
    statements: 'Statements',
    certificates: 'Certificates',
    MSDS: 'SDS',
    marketingInformation: 'Marketing Information',
    marketingInformationPremium: 'Marketing Information (Club)',
    relatedliterature: 'Related literature',
    youCanCompare: 'You can compare',
    brandAtMost: 'Brand at most !',
    productsAtMost: 'Products at most !',
    formulationAtMost: 'Formulation at most !',
    ingredientAtMost: 'Ingredient at most !',
    addMore: 'Add more',
    brand_: 'brand',
    marketInformation: 'Market Information',
    functionalIngredientList: 'Functional Ingredient List',
    ingredientList: 'Ingredient List',
    consumerSkinType: 'Consumer Skin Type',
    dataSource: 'Data Source',
    BEVOL: 'BEVOL',
    socialMedia: 'Social Media',
    otherWebsite: 'Other Website',
    consumerInformation: 'Consumer Information',
    skinType: 'Skin Type',
    gender: 'Gender',
    consumerArea: 'Consumer Location',
    age: 'Age',
    priceRange: 'Price Range',
    ranking: 'Ranking',
    previousRank: 'Previous Rank',
    clickRate: 'Click Rate',
    relatedConcepts: 'Related Concepts',
    conceptsFounded: 'Concepts found.',
    area: 'Area',
    recentlyViewed: 'Recently Viewed',
    yourBrand: 'Your Brand',
    previousSelection: 'Previous Selection',
    previousViewed: 'Previous Viewed',
    newFormulationDetail: 'New Formulation Detail',
    claimSubstantiation: 'Claim Substantiation',
    documents: 'Documents',
    prototypeSize: 'Prototype Size',
    capacity: 'Capacity',
    quantity: 'Quantity',
    additionalClaimsTexturesForms: '(Additional Claims, Textures, Forms...)',
    shippingInformation: 'Shipping Information',
    contactName: 'Contact Name',
    email: 'E-mail',
    companyName: 'Company Name',
    address: 'Address',
    prototypeDeliveryOptions: 'Prototype Delivery Options',
    months: 'Months',
    yourOrderPlaced: 'Your Order Has Been Placed!',
    summary: 'Summary',
    BASFContactInformation: 'BASF Contact Information',
    myOrderList: 'My Order List',
    orderId: 'Order Id',
    Categorys: 'Category',
    creatTime: 'Create Time',
    dashboard: 'Dashboard',
    allDataRelated: 'All data related to click start with April.2018',
    productNumber: 'Product number  ',
    productDetail: 'Product Detail',
    allResult: 'All Result',
    products: 'Products',
    concepts: 'Concept',
    conceptsPremium: 'Concept (Club)',
    relevantSearchOf: 'Relevant Search of',
    ingridientName: 'Ingredient Name',
    document: 'Document',
    lastUpdate: 'Last Update',
    updateYear: 'Update Year',
    conceptsfounded: 'Concepts founded.',
    video: 'Video',
    videoPremium: 'Video (Club)',
    scientificDocument: 'Scientific Document',
    relatedConsumerOnsight: 'Related consumer insight',
    relatedBASFFormulation: 'Related BASF Formulation',
    focusedBASFProducts: 'Focused BASF products',
    claimsCategory: 'Claims/Category',
    province: 'Province',
    commentsRate: 'Comments Rate',
    clicksRate: 'Clicks Rate',
    PCRMO: 'Personal Care Retail Market Overview',
    AsiaPacificView: 'Asia Pacific View',
    MapView: 'Map View',
    NOAPEC: 'Numbers on Asia Pacific & each country',
    EURMillion: 'EUR Million',
    clickHere: 'Click here',
    changePassword: 'Change Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    contactMail: 'If you have any question with this system, please contact with the mail: ',
    loginInformation: 'For our better service, please login your information.',
    targetMarket: 'Target Market',
    benchmarkBrand: 'Benchmark Brand',
    benchmarkProduct: 'Benchmark Products',
    benchmarkFormu: 'Benchmark Formulation',
    userName: 'User Name',
    userRole: 'User Role',
    userGroup: 'User Group',
    expertFeedback: 'Expert Feedback',
    module: 'Module',
    page: 'Page',
    score: 'Score',
    productDistribution: 'Product Distribution',
    noAuthority: 'No authority at present',
    changePasswordTip: 'Your password has expired. Please change your password.',
    similarFormulation: 'Formulations with similar claims',
    interestFormulation: 'Formulations that you may also like',
    KeyBASFProduct: 'Key BASF Product',
    nothingForYou: 'wow, that’s interesting, can we design something new',
    source: 'Source',
    lifestyle: 'Lifestyle',
    keyword: 'Key word',
    countryRegion: 'Locations',
    productFocus: 'Product Focus',
    brandFocus: 'Brand Focus',
    targetDemographicCare: 'Target Demographic Care',
    keyWords: 'Key Word',
    submitBy: 'Submitted By',
    approver: 'Approver',
    uploader: 'Uploader',
    uploadTime: 'Upload Time',
    platform: 'Platform',
    feedbackTime: 'Feedback Time',
    approveTime: 'Approve Time',
    updateTime: 'Update Time',
    download: 'Download',
    status: 'Status',
    file: 'File',
    approveComment: 'Approval Comment',
    allReplies: 'All Replies',
    replied: 'replied',
    subCategory: 'Sub-Category',
    picture: 'Picture',
    all: 'All',
    basfProduct: 'BASF Product',
    rating: 'Rating',
    trend: 'Trend',
    addConcept: 'Add New Concept - Upload files',
    editConcept: 'Edit New Concept - Upload files',
    addOldConcept: 'Add Old Concept',
    editOldConcept: 'Edit Old Concept',
    agreement: '利用規約への同意',
    privacy: 'Data Privacy Statement',
    verificationCode: 'Verification code',
    getCode: 'Get verification code',
    checkCode: 'Please check the verification code in the email',
    forgetPassword: 'Forget Password',
    chooseDate: 'Select a date',
    benchmarkFormulation: 'Benchmark Formulation',
    agreeWithBasf: 'Agree with BASF',
    legalTitle: 'legal agreement',
    privacyTitle: 'privacy',
    sortByInci: 'sort by based on last quarter data: ',
    newUser: 'New User ?',
    qrCodeTips: 'Please scan the QR code to download the App and register using the App',
    showInFronEnd: 'Show in Front End',
    commentSetting: 'Comment Setting',
    commentApprove: 'Comment needs to be approved before shown in frontend',
    containingIngredient: 'Related formulations containing this ingredient',
    relatedFormulations: 'Related Formulations containing both <span>{inci}</span> and <span>{selectInci}</span>',
    noDataExport: 'No data to export',
    goTop: 'Go top',
    default: 'Default',
    minutes: 'Minutes',
    user: 'User',
    role: 'Role',
    targetUser: 'Target Users',
    targetRole: 'Target Role',
    visibleUser: 'Visible to selected users',
    invisibleUser: 'Invisible to selected users',
    lastActive: 'Days Since Last Active',
    customize: 'Customize',
    delete: 'Delete',
    preference: 'Preference',
    pushStatus: 'PUSH Notification',
    statusOff: 'off',
    statusOn: 'on',
    videoDetail: 'Video Detail',
    filter: 'Filter',
    searchCategory: 'Search this category',
    channel: 'Channel',
    specificUserOnly: 'Specific user only',
    similarConsumerBenefitClaim: 'Similar Consumer Benefit/Claim',
    similarIngredinet: 'Similar Ingredient(s)',
    similarFunction: 'Similar Function(s)',
    formDelivery: 'Form of delivery',
    releasedCountry: 'Released country',
    NA: 'N/A',
    userCenter: 'User Center',
    deleteTips: 'Are you sure you want to delete?',
    inputUserAccount: 'Input user account',
    inputRoleName: 'Input role name',
    bevol: 'BEVOL APP in China',
    duration: 'Duration',
    toxAbstract: 'Tox Abstract',
    // 品牌属性
    brandProps: {
      brandPositioning: 'Brand Positioning',
      pricePositioning: 'Price positioning',
      origin: 'Origin',
      retailValue: 'Retail Value',
      marketShare: 'Market Share',
      growthRate: 'Growth Rate',
      productAmount: 'Product Amount',
      nature: 'Nature',
      general: 'General',
      technology: 'Technology',
      mass: 'Mass',
      masstige: 'Masstige',
      premium: 'Premium',
      group: 'Group',
      specificPopulationGroups: 'Specific population Groups',
      mainClaim: 'Main claim',
      productsQuantity: 'Products Quantity',
      clicks: 'Clicks',
      ranking: 'Ranking',
      JPGFormat: 'Upload head picture can only be in JPG format!',
      pictureSize: 'The size of uploaded avatar pictures should not exceed 2MB!',
      brandGroup: 'Brand Group',
      officialLink: 'Official link',
      majorCategory: 'Major Product Category',
      majorSubCategory: 'Major Product Sub-category'
    },
    // 产品属性
    prodProps: {
      brand: 'Brand',
      productCategory: 'Product category',
      price: 'Price',
      brandOrigin: 'Brand Origin',
      productForm: 'Product form',
      capacity: 'Capacity',
      market: 'Market',
      applicationArea: 'Application area',
      CFDARegistrationYear: 'NMPA Registration year',
      brandGroup: 'Brand group',
      dataFromCFDA: 'Data from NMPA',
      claim: 'Claim',
      mainIngredients: 'Main ingredients',
      functionIngredients: 'Function ingredients',
      clicks: 'Clicks',
      commentScore: 'Comment score',
      comments: 'Comments',
      rank: 'Rank',
      manufacture: 'Manufacture',
      launchYear: 'Launch Year',
      internationalType: 'Registration Version (International)',
      CFDAType: 'Registration Version (NMPA)',
      versions: 'versions'
    },
    // 配方属性
    fomuProps: {
      country: 'Laboratory country',
      productCategory: 'Product category',
      applicatioArea: 'Application area',
      subApplicationArea: 'Sub-Application area',
      productForm: 'Product form',
      ProductAspect: 'Product Aspect',
      formulationID: 'Formulation ID',
      author: 'Author',
      ownerName: 'Owner',
      ownerEmail: 'Owner email',
      sunscreenLevel: 'Sunscreen Level',
      functionalClaim: 'Functional Claim',
      emotionalClaim: 'Emotional Claim',
      sensoryClaim: 'Sensory Claim',
      priceRange: 'Price range',
      // boss new formulation
      claims: 'Claims',
      category: 'Category',
      formAspect: 'Form/Aspect',
      sunscreenLevelSPF: 'Sunscreen Level-SPF',
      sunscreenLevelPA: 'Sunscreen Level-PA',
      specificPopulationGroups: 'Specific Population Groups',
      insertPriceRange: 'Insert Price Range',
      applicationArea: 'Application Area',
      BASFFormulation: 'BASF formulation',
      productBenchmark: 'Product benchmark',
      currency: 'Currency',
      subArea: 'Sub Area',
      BASFProposedFormulation: 'BASF proposed formulation',
      ingredients: 'Ingredients',
      releaseRegion: 'Release region'
    },
    // 美修成分属性
    ingrdProps: {
      among: 'among all ingredients',
      category: 'Category',
      function: 'Function',
      functionalClaim: 'Functional Claim',
      CASNumber: 'CAS Number',
      clicks: 'Clicks',
      relatedTradeName: 'BASF Product containing this ingredient',
      favorites: 'Favorites',
      registrationArea: 'Release Locations',
      comments: 'Comments',
      subCategory: 'Sub-category',
      click: 'Click',
      userClick: 'DLitE3.x user clicks',
      productAmong: 'Mostly used among consumer products',
      bevolClicks: 'Clicks in Bevol last quater',
      dlite3Clicks: 'Clicks in D’litE3X last quater',
      productCount: 'Products containing this INCI last quater',
      rateTips: 'Rate=Products containing this ingredient/All products by filter'
    },
    // 巴斯夫成分属性
    tradeProps: {
      Number: 'Number',
      PRDNumber: 'PRD Number',
      ownerName: 'Owner',
      ownerEmail: 'Owner email',
      formDelivery: 'Form of Delivery',
      function: 'Function',
      application: 'Application',
      productGroup: 'Product group',
      consumerBenefit: 'Consumer Benefit',
      INCIID: 'INCI ID',
      INCIName: 'INCI Name',
      bMark: 'B mark',
      eco_Status: 'Eco-Status',
      releasedCountry: 'Released Country',
      valueProposition: 'Value Proposition',
      submittedBy: 'Submitted by',
      basfProductName: 'BASF Product Name',
      competitor: 'Related product from other companies',
      warningCarefully: 'This changing will infect all other modules, carefully when you do it.',
      consumerBenefitTips: 'You can choose 20 consumer benefit at most.',
      toBeConfirmed: 'To be confirmed',
      usedInBASFName: 'Used in BASF Products',
      uploadResult: 'Upload BASF Mark Result',
      downloadResult: 'Download Upload Result',
      uploadFile: 'Upload File',
      changeFile: 'Change File',
      uploadTips: 'Please use the exported file to upload the updated data.',
      uploadSuccess: 'Success',
      uploadFailure: 'Failure',
      resultTips: 'System will automatically download the upload result for you, or you can click the link below to download directly.',
      uploadRequire: 'Upload failed, please upload the required Excel file',
      searchFor: 'Search for',
      moreFilter: 'More filter',
      resetFilter: 'Reset Filter',
      qdName: 'QD Name',
      qdNameTips: 'QD Name will be displayed on Japanese version only.',
      displayQDName: 'Display QD Name',
      addToCart: 'Add to Cart',
      yourInformation: 'Your Information',
      cartIsEmpty: 'Your shopping cart is empty',
      items: 'Items',
      BASFProductList: 'BASF Product list',
      additionalRequests: 'Additional requests for other products',
      additionalRequestsTips: 'Please state any other products or requests',
      languageTips: 'In which language setting will the BASF Product be presented'
    },
    // 概念成分属性
    conceptProps: {
      // Concept: 'Concept',
      // Approved: 'Approved',
      // pendingApproval: 'Pending Approval',
      // Denled: 'Denled',
      // Draft: 'Draft',
      // Region: 'Region',
      // Country: 'Country',
      // Type: 'Type',
      // Segment: 'Segment',
      // Position: 'Position',
      // updateYear: 'Update year'
    },
    conceptMenu: {
      // Name: 'Name',
      // upfateYear: 'Update Year',
      // Reglon: 'Reglon',
      // Country: 'Country',
      // Segment: 'Segment',
      // Type: 'Type',
      // Position: 'Position',
      // uploadTime: 'Upload Time',
      // Uploader: 'Uploader',
      conceptList: 'Concept List',
      Approved: 'Approved',
      pendingApproval: 'Pending Approval',
      Denied: 'Denied',
      Draft: 'Draft'
      // CommentRating: 'Comment/Rating',
      // Operation: 'Operation'
    },
    oldConceptsEdit: {
      // editOldConcept: 'Edit Old Concept',
      // Area: 'Area',
      // updateYear: 'Update Year',
      // Segment: 'Segment'
    },
  },
  searchMenu: {
    brand: 'Brand',
    product: 'Products',
    formulation: 'Formulation',
    ingredient: 'Ingredient',
    concept: 'Concept',
    basfProduct: 'BASF Product',
    general: 'General',
    event: 'Event'
  },
  menu: {
    brand: 'Brand Analytics',
    product: 'Consumer Products',
    formulation: 'Formulation Design',
    ingredient: 'Ingredient Selection',
    concept: 'Concept',
    consumer: 'Consumer Insights',
    boss: 'BOSS',
    video: 'Introduction Video',
    dataManagement: 'Data Management',
    dataUpload: 'My Data Upload',
    dataRelationship: 'Data Relationship'
  },
  breadCrumb: {
    home: 'HOME',
    brand: 'Brand Analytics',
    brandDetail: 'Brand Detail',
    boss: 'BOSS',
    comprehensiveSearch: 'Comprehensive Search',
    advancedSearch: 'Advanced Search',
    formulationNewDesign: 'Formulation New Design',
    purchase: 'Purchase',
    myOrder: 'My Order',
    consumerProducts: 'Consumer Products',
    consumerProductsDetail: 'Consumer Products Detail',
    productComparison: 'Product Comparison',
    brandComparison: 'Brand Comparison',
    formulationComparison: 'Formulation Comparison',
    ingredientComparison: 'Ingredient Comparison',
    ingredientSelection: 'Ingredient Selection',
    formulationDesign: 'Formulation Design',
    formulationDetail: 'Formulation Detail',
    ingredientDetail: 'Ingredient Detail',
    tradeNameDetail: 'BASF Product Detail',
    consumerInsights: 'Consumer Insights',
    trend: 'Trend',
    trendList: 'Trend List',
    trendDetail: 'Trend Detail',
    marketOverview: 'Market Overview',
    topRanking: 'Top Ranking',
    conceptsCollection: 'Concept',
    newConceptsList: 'New concepts list',
    oldConceptsList: 'Old concepts list',
    viewMore: 'View More',
    euperlanOPWhite: 'Euperlan ®  OP White',
    orderDetail: 'Order Detail',
    bossProduct: 'Products',
    conceptDetail: 'Concept Detail',
    BASFProduct: 'BASF Product',
    BASFProductUpload: 'BASF Product',
    formulation: 'Formulation',
    formulationUpload: 'Formulation',
    trendManagement: 'Trend',
    trendUpload: 'Trend',
    concept: 'Concept',
    conceptUpload: 'Concept',
    accounts: 'Accounts',
    role: 'Role',
    userBehavior: 'User Behavior',
    feedback: 'Feedback',
    commentData: 'Comment Data',
    visitData: 'Visit Data',
    lifestyleSegment: 'Lifestyle&Segment&Keyword',
    event: 'Event',
    eventSpeaker: 'Speakers',
    eventFormulationCategory: 'Formulation Segment',
    eventFormulation: 'Formulations',
    eventProductCategory: 'BASF Product Segment',
    eventSolution: 'Solution',
    eventProduct: 'BASF Products',
    webinar: 'Webinar',
    introVideo: 'E-Learning',
    introVideoList: 'E-Learning List',
    care: 'detail',
    topManagement: 'Top ranking-Other Website',
    productDetail: 'Add Product',
    sourceDetail: 'Edit Source',
    formuCategory: 'Formulation - Category',
    formuProduct: 'Formulation - BASF Product',
    userGroup: 'User Group',
    message: 'Message',
    aboutBASF: 'About BASF',
    appPictures: 'Pictures',
    topRrankingSourceIndexstatus: 'Edit Source',
    otherWebsiteEditProductStatus: 'Edit product',
    delivery: 'Form of delivery',
    application: 'Application',
    benefit: 'Consumer benefit',
    productGroup: 'Product group',
    inciBasfMark: 'INCI BASF Mark',
    competitor: 'Product from other companies',
    claim: 'Claim',
    brandClaim: 'Brand Claim',
    formfunction: 'Function',
    messageCenter: 'Message Center',
    coownerSetting: 'Co-owner setting',
    activityLog: 'Activity Log',
    announcement: 'Announcement',
    technicalSupport: 'Technical Support',
    whiteList: 'White List',
    orderList: 'Order List',
    qrCode: 'QR Code',
    dliteFunction: "D'litE Function",
    basfFunction: 'BASF Product Function',
    bevolFunction: 'Bevol Function',
    inciManagement: 'Ingredient',
    userPortrait: 'User Portrait',
    visitDataAnalysis: 'Visit Data Analysis',
    push: 'PUSH Management',
    media: 'Video',
    tagSearch: 'Video Tag',
    homePage: 'Home Page',
    globalPage: 'D\'litE3X Global',
    myProfile: 'My Profile',
    commentKeywords: 'Comment keywords',
    eventTrend: 'Trends',
    eventConcept: 'Concepts',
    eventClient: 'Event',
    eventDetail: 'Event Detail',
    webinarClient: 'Webinar',
    webinarDetail: 'Webinar Detail',
    blackList: 'Black List',
    deeplink: 'Deeplink',
    keywordLibrary: 'Keyword Library'
  },
  // 图表
  chart: {
    retailValue: 'Retail Value',
    marketShare: 'Market Share',
    CAGR: 'CAGR',
    growthRate: 'growth rate',
    rate: 'Rate',
    number: 'Number',
    // 品牌模块
    brand: {
      // List页面
      BPM: 'Brand Positioning Map (Retail Value & Growth Rate)',
      T5PC: 'Distribution of brands among Top 5 claims',
      CPD: 'Distribution of brands by Categories',
      T10CCP: 'Distribution of brands among Top Claims & Categories',
      // detail --> Market Data
      BRVMS: 'Brand Retail Value & Market Share',
      BRVGR: 'Brand Retail Value & Growth Rate',
      MS: 'Market Share',
      // detail --> Basic Data
      clicks: 'Clicks',
      comments: 'Comments',
      PDBC: 'Product distribution by category',
      // detail --> Products & Claims
      T5CALP: 'Top 5 Claims Among Launched Products',
      T3BNL: 'Top 3 Brand New Launched',
      ALPD: 'Annual launched products distribution',
      APD: 'Annual products distribution',
      ALPCD: 'Annual launched Product Category Distribution',
      T10P: 'Top 10 Products',
      // detail --> Ingredients & Consumer
      IUT: 'Ingredient Using Trend',
      AD: 'Annual data',
      CC: 'Consumer Clicks',
      CL: 'Consumer Location',
      CST: 'Consumer Skin Type',
      CG: 'Consumer Gender',
      rateTips: 'Rate=Products containing this ingredient/All products by filter',
      top5ClaimsTips: 'Latest 6 years：Top 5 claims among products launched in latest 6 years<br />Latest 3 years：Top 5 claims among products launched in latest 3 years',
      productLaunchYear: 'Product Launch Year',
      year: 'Year',
      season: 'Season',
      dbClickTips: 'Double click highlight zone to view more detail'
    },
    product: {
      // list
      T10CPF: 'Top 10 Claims&Product Form',
      T10CSC: 'Top 10 Claims&Sub-category',
      T10PDCF: 'Top 10 products distribution by Claim&Product Form',
      T10PDCC: 'Top 10 products distribution by Claim&Sub-category',
      // detail
      FA: 'Feedback analysis',
      CCL: 'Consumer Clicks Location',
      HL: 'Location',
      T10C: 'Top 10 comments',
      CCST: 'Comment consumer skin type',
      CCA: 'Comment consumer age',
      Clicks: 'Clicks',
      Location: 'Location',
      ST: 'Skin type',
      Age: 'Age',
      productClaimLandscape: 'Product Claim Landscape',
      // dashboard
      MPCT10: 'Top 10 products by click in last month',
      IUTTVLM: 'Ingredients Using Trend Top10 VS Overall',
      MBCT10: 'Top 10 brands by click in last month',
      ANLCD: 'Annual New Launched Claims Distribution',
      ANP: 'Annual New Products'
    },
    ingredient: {
      products: 'Ingredients application analysis',
      byCategory: 'By Category',
      T10PCZO: 'Top 10 products containing',
      IUT: 'Ingredient Using Trend'
    },
    insight: {
      T10C: 'Top 10 Claims',
      PCRMO: 'Personal Care Retail Market Overview',
      SRVGR: 'Segment Retail Value & Growth Rate',
      SSRVGR: 'Sub-Segment Retail Value & Growth Rate',
      T10CBRVMS: 'Top 10 Companies / Brands Retail Value & Market Share',
      CBP: 'Top 5 Company/Brand Performance',
      amongBrand: 'Top xx% among all brands',
      amongProduct: 'Top xx% among all products'
    }
  },
  // dialog
  dialog: {
    editOldConcept: 'Edit Old Concept',
    editNewConcept: 'Edit New Concept'
  },
  // 按钮名称
  btn: {
    login: 'LOGIN',
    register: 'REGISTER',
    forgetPassword: 'Forget Password',
    changePassword: 'Change Password',
    add: 'Add',
    yes: 'Yes',
    apply: 'Apply',
    cancel: 'Cancel',
    ok: 'OK',
    send: 'Send',
    order: 'My Order',
    search: 'Search',
    submit: 'Submit',
    reply: 'Reply',
    confirm: 'Confirm',
    week: 'Week',
    month: 'Month',
    collapse: 'Collapse',
    viewAll: 'View All',
    feedback: 'Feedback',
    year: 'Year',
    exportAllResult: 'Export All Document',
    addToCompare: 'Add to Compare',
    downloadPDF: 'Download PDF',
    downloadPPT: 'Download PPT',
    askForNewDesignBenchmark: 'Ask for new design as a Benchmark',
    askForNewDesign: 'Ask for new design',
    addFomulationCompare: 'Add to Formulation Compare',
    export: 'Export',
    confirmationSubmission: 'Confirmation Submission',
    confirmResetPassword: 'Confirm reset password?',
    AddMoreBrand: 'Add more brand',
    AddMoreProduct: 'Add more product',
    AddMoreFormulation: 'Add more formulation',
    AddMoreIngredient: 'Add more ingredient',
    hide: 'Hide',
    viewMore: 'View More',
    forProducts: 'Top Products',
    forClaims: 'Top Claims',
    forBrand: 'Top Brands',
    forGroup: 'Top Group',
    advancedSearch: 'Advanced Search',
    purchase: 'Purchase',
    viewMoreConcepts: 'View More Concepts',
    trend: 'Trend',
    marketOverview: 'Market Overview',
    topRanking: 'Top Ranking',
    reset: 'Reset',
    resetPassword: 'Reset',
    previousStep: 'Previous step',
    previous: 'Previous',
    back: 'Back',
    nextStep: 'Next',
    changeAvatar: 'Change Avatar',
    technicalSupport: 'Technical Support',
    newConcepts: 'New concepts',
    oldConcepts: 'Old concepts',
    edit: 'Edit',
    pendingCheck: 'Approve/Deny',
    approve: 'Approval',
    deny: 'Deny',
    withdraw: 'Withdraw',
    view: 'View',
    preview: 'Preview',
    draft: 'Save as Draft',
    change: 'Change',
    upload: 'Upload',
    uploadFile: 'Upload file',
    enable: 'Enable',
    disable: 'Disable',
    set: 'Set',
    sendApplication: 'Send Application',
    contactUs: 'Contact Us',
    contactUsByEmail: 'For technical support, please contact us by{current}',
    refresh: 'Refresh',
    signOut: 'Sign Out'
  },
  statusTab: {
    allApproved: 'All Approved',
    allPending: 'All Pending Approval',
    allDenied: 'All Denied',
    approved: 'Approved',
    pending: 'Pending Approval',
    denied: 'Denied',
    draft: 'Draft'
  },
  // 下拉框选项
  select: {
    clicks: 'Clicks',
    favorite: 'Favorite',
    comments: 'Comments',
    byClicks: 'By Clicks',
    byFavorites: 'By Favorite',
    byComments: 'By Comments',
    female: 'Female',
    male: 'Male',
    dryRigid: 'Dry-Resistant',
    drySensitive: 'Dry-Sensitive',
    oilyRigid: 'Oily-Resistant',
    oilySensitive: 'Oily-Sensitive',
    standard: 'Standard',
    express: 'Express',
    updateTime: 'Update Time'
  },
  tabs: {
    // brand
    briefAnalysis: 'Brief Analysis',
    brandList: 'Brand List',
    // brand --> brand detail
    marketData: 'Market Data',
    basicData: 'Basic Data',
    productsClaims: 'Products & Claims',
    ingredientsConsumer: 'Ingredients & Consumer',
    brandGroup: 'Brand Group'
  },
  // 输入框提示
  placeholder: {
    username: 'Username',
    password: 'Password',
    keyword: 'Enter keyword',
    keyWords: 'Key Words',
    year: 'Year',
    country: 'Country',
    segment: 'Segment',
    subSegment: 'SubSegment',
    age: 'Age',
    priceRrange: 'Price',
    to: 'to',
    start: 'Start Date',
    end: 'End Date',
    brandSearch: 'Brand Search',
    category: 'Category',
    brandGroup: 'Brand Group',
    brandPositioning: 'Brand Positioning',
    pricePositioning: 'Price Positioning',
    function: 'Function',
    functionClaim: 'Functional Claim',
    brand: 'Brand',
    productForm: 'Product Form',
    productAspect: 'Product Aspect',
    sunscreenLevelSPF: 'Sunscreen Level-SPF',
    sunscreenLevelPA: 'Sunscreen Level-PA',
    specificPopulationGroups: 'Specific Population Groups',
    applicationArea: 'Application Area',
    subArea: 'Sub-area',
    functionalClaim: 'Functional Claim',
    emotionalClaim: 'Emotional Claim',
    sensoryClaim: 'Sensory Claim',
    tradename: 'Tradename',
    INCI: 'INCI',
    tags: 'Tags',
    registeredCountry: 'Release Locations',
    formDelivery: 'Form of delivery',
    ecoSatus: 'Eco status',
    skinType: 'Skin type',
    gender: 'Gender',
    province: 'Province',
    consumerArea: 'Consumer Location',
    search: 'Search',
    INCLUDEDIngredients: 'INCLUDED Ingredients',
    EXCLUDEDIngredients: 'EXCLUDED Ingredients',
    capacity: 'Capacity',
    quantity: 'Quantity',
    pleaseEnterContent: 'Please enter content',
    contactName: 'contactName',
    email: 'email',
    companyName: 'companyName',
    address: 'address',
    activeIngredient: 'Active Ingredient',
    oldPassword: 'old password',
    newPassword: 'new password',
    confirmPassword: 'confirm password',
    commentsHere: 'Your comments here',
    source: 'Source',
    lifestyle: 'Lifestyle',
    targetDemographicCare: 'Target Demographic Care',
    productFocus: 'Product Focus',
    sortBy: 'Sort By',
    language: 'Language',
    countryRegion: 'Country Region',
    submitBy: 'Submit By',
    approver: 'Approver',
    uploader: 'Uploader',
    operation: 'Operation',
    type: 'Type',
    pleaseSelect: 'Select',
    brandGroupSearch: 'Brand Group Search'
  },
  validate: {
    username: {
      require: 'Account cannot be empty.'
    },
    password: {
      require: 'Password cannot be empty.'
    },
    email: {
      required: 'E-mail is required',
      pattern: 'Illegal E-mail'
    },
    ownerName:{
      require: 'Owner cannot be empty.'
    },
    emailLength: 'e-mail cannot exceed 50 characters'
  },
  legend: {
    thisMonth: 'This month',
    overall: 'Overall',
    OR: 'Oily-Resistant(OR)',
    OS: 'Oily-Sensitive(OS)',
    DR: 'Dry-Resistant(DR)',
    DS: 'Dry-Sensitive(DS)',
    NA: 'Not Answered'
  },
  series: {
    skinType: 'Skin type'
  },
  compare: {
    brand: 'Brand',
    product: 'Product',
    formulation: 'Formulation',
    ingredient: 'INCI'
  },
  trend: {
    name: 'Trend name',
    ownerName: 'Owner',
    ownerEmail: 'Owner email',
    pictureNeeded: 'Picture before PDF and PPT',
    picture: 'Picture',
    country: 'Locations',
    addFile: 'Add File',
    largeFile: 'Only accept file smaller than',
    add: 'Add New Trend',
    addLifestyle: 'Add Lifestyle',
    addKeyword: 'Add Keyword',
    addSegment: 'Add Segment',
    editLifestyle: 'Edit Lifestyle',
    editKeyword: 'Edit Keyword',
    editSegment: 'Edit Segment',
    edit: 'Edit Trend',
    basic: 'Basic Information',
    attribute: 'Attribute Information',
    keyword: 'Key Words',
    approve: 'Trend  Approval',
    preview: 'Trend Information Preview',
    position: 'Position',
    trendName: 'Trend Name',
    trending: 'What\'s Trending',
    addTrending: 'add to what\'s trending',
    weight: 'Weight',
    rate: 'Rate',
    webView: 'Web View',
    APPView: 'APP View',
    allRequired: 'Please complete all required items',
    pdfNppt: 'File required',
    user: 'Target User',
    userGroup: 'Target User Group',
    userTips: 'Description: If you choose target user and user group, only the users you chosen can view this trend; otherwise everyone user can view this trend.',
    videoTips: '*Only MP4 for video is supported. MP4 < 50mb',
    video: 'Video',
    videoPicture: 'Video Picture',
    trend: 'Trend',
    trendPremium: 'Trend (Club)',
    filePremium: 'File (Club)',
    videoPremium: 'Video (Club)',
    videoPicturePremium: 'Video Picture (Club)',
    fileInternal: 'File (Internal)',
    videoInternal: 'Video (Internal)',
    videoPictureInternal: 'Video Picture (Internal)',
    premiumTips: 'If you need to upload trend files, a PDF file is mandatory',
    trendFileTips: 'Trend file is required',
    description: 'Description',
    trendInternal: 'Trend (Internal)',
    trendFile: 'Trend Files',
    trendFileClub: 'Trend Files (Club)',
    trendFileInternal: 'Trend Files (Internal)',
    productFocus: 'Product Focus',
    targetDemographicCare: 'Target Demographic Care'
  },
  formulation: {
    add: 'Add New Formulation',
    edit: 'Edit Formulation',
    addChineseFormulation: 'Add chinese formulation',
    subTitle: 'Sub-Title',
    form: 'Form',
    view: 'View',
    approval: 'Approval',
    uploadFile: 'Upload File',
    uploadImage: 'Upload Image',
    enUploadFile: 'Upload File:(English)',
    enTitle: 'Title:(English)',
    enSubTitle: 'Sub-title:(English)',
    updatePdfFail: 'uploading failure, please upload PDF file',
    updateImageFail: 'uploading failure, please upload jpg or png file',
    extract: 'Extract',
    inputEmpty: 'input information can’t be empty',
    extractPDF: 'Pleas extract PDF file first',
    extractFailed: 'Extract Failed. <br />Please re-upload and try again.',
    disableFormulation: 'Are you sure to <strong class="disable">DISABLE</strong> the formulation below?',
    enableFormulation: 'Are you sure to <strong class="enable">enable</strong> the formulation below?',
    formulationID: 'Formulation ID',
    titleEnglish: 'Title(English)',
    titleChinese: 'Title(Chinese)',
    titleJapanese: 'Title(Japanese)',
    title: 'Title',
    subCategory: 'Sub-Category',
    SPF: 'SPF',
    PA: 'PA',
    uploadPDFEnglish: 'Upload PDF(English)',
    uploadPDFChinese: 'Upload PDF(Chinese)',
    uploadPDFJapanese: 'Upload PDF(Japanese)',
    views: 'View',
    subTitleChinese: 'Sub-title(Chinese)',
    subTitleEnglish: 'Sub-title(English)',
    subTitleJapanese: 'Sub-title(Japanese)',
    descriptionEnglish: 'Description(English)',
    descriptionChinese: 'Description(Chinese)',
    descriptionJapanese: 'Description(Japanese)'
  },
  topRanking: {
    brand: 'Brand',
    product: 'Product',
    productTips: 'Rate means Top xx% among all products',
    brandTips: 'Rate means Top xx% among all brands',
    dataSource: 'Data Source',
    bevol: 'BEVOL',
    others: 'Others',
    topClaims: 'Top Claims',
    topProducts: 'Top Products',
    topBrands: 'Top Brands',
    topIngredients: 'Top Ingredients',
    showFilters: 'Show filters',
    hideFilters: 'Hide filters',
    quater: 'Quarter',
    referenceDate: 'Reference Date',
    comparisonDate: 'Comparison Date',
    rankingRules: 'Ranking Rules',
    productInformation: 'Product Information',
    category: 'Category',
    priceRange: 'Price Range',
    consumerInformation: 'Consumer Information',
    consumerLocation: 'Consumer Location',
    skinType: 'Skin Type',
    gender: 'Gender',
    age: 'Age',
    brandInformation: 'Brand Information',
    brandGroup: 'Brand Group',
    brandPositioning: 'Brand Positioning',
    pricePositioning: 'Price Positioning',
    ingredientInformation: 'Ingredient Information',
    function: 'Function',
    functionalClaim: 'Functional Claim',
    releaseLocations: 'Release Locations',
    top10Claims: 'Top 10 Claims',
    top10Products: 'Top 10 Products',
    ranking: 'Ranking',
    productName: 'Product',
    brandName: 'Brand',
    click: 'Click',
    comment: 'Comment',
    favorite: 'Favorite',
    top10Ingredients: 'Top 10 Ingredients',
    top10Brands: 'Top 10 Brands',
    relatedFormulation: 'Related Formulation',
    relatedConcept: 'Related Concept',
    mostlyUsed: 'Claims mostly used with <span style="color: #21BDBB; font-size: 14px;">“{current}”</span>',
    mostlyUsedTips: 'Other claims that are mostly used based on the products with the claims selected',
    filter: 'Filters',
    date: 'Date'
  },
  comment: {
    trend: 'How likely are you going to adapt this trend?',
    concept: 'How likely are you going to adapt this concept?',
    consumerProduct: 'How likely are you going to adapt this consumer product?',
    formulation: 'How likely are you going to adapt this formulation?',
    product: 'How likely are you going to adapt this product?',
    inci: 'How likely are you going to adapt this INCI?',
    eLearning: 'How likely are you going to adapt this eLearning?',
    brand: 'How likely are you going to adapt this brand?'
  },
  webinar: {
    day: 'Day',
    viewed: 'Viewed',
    segment: 'Segment',
    speaker: 'Speaker',
    addNewWeb: 'Add New Webinar',
    editWeb: 'Edit Webinar',
    webTitle: 'Webinar Title',
    subscriberEmailList: 'Subscriber Email List',
    keyTopic: 'Key Topic',
    keyVisual: 'Key Visual',
    representative: 'BASF Representative',
    submissionTime: 'Submission Data & Time',
    start: 'start in',
    inTime: 'In CN-HK time',
    picture: 'Main picture',
    title: 'Title',
    speakerTitle: 'Speaker Title',
    speakerName: 'Speaker Name and Speaker Title',
    speakerPicture: 'Speaker Picture',
    learnMore: 'learn more about BASF solution',
    forumWelcome: 'BASF D’lite3x forum welcome our honorable partners.',
    contactRepresentative: 'contact your BASF representative or subcribe today to recieve newsletter',
    yourEmail: 'your e-mail address',
    basfRepresentative: 'BASF representative',
    exploreMoreConcepts: 'Explore More Concepts',
    pdfTitle: 'PDF Title',
    pdfFile: 'PDF File',
    pdfImage: 'PDF Picture',
    videoTitle: 'Video Title',
    videoFile: 'Video File',
    videoImage: 'Video Picture',
    tips: 'Tips',
    reallyChangeStatus: 'Really change status?',
    addNewVideo: 'Add New Video',
    editNewVideo: 'Edit New Video',
    editVideo: 'Edit Video',
    firstPlace: 'add this event to the first place.',
    add: 'add',
    webinarTitle: 'Webinar title',
    sortBy: 'Sort by',
    startTime: 'Start Time',
    createTime: 'Create Time',
    clickHere: 'Want to get a sample? Click Here!',
    choose: 'Choose to request samples',
    request: 'Request samples items',
    submitRequest: 'Submit Request',
    items: 'Items',
    email: 'Email',
    telephone: 'Telephone',
    additionalRequests: 'Additional Requests',
    addSuccessfully: 'Add successfully.',
    experience: 'We’d love to hear from you about your webinar experience!',
    goToParticipate: 'Go to participate',
    leaveUs: 'Leave us any inquiries and questions here!',
    type: 'Type',
    feedback: 'Feedback',
    content: 'Content',
    successfulFeedback: 'Successful submission of feedback.',
    materials: 'Webinar Key takeaways and Presentation Materials',
    sampleRequest: 'Sample Request',
    detail: 'Detail',
    creator: 'Creator',
    fillInSurvey: 'Fill in Survey',
    viewRelatedContents: 'View Related Contents',
    postalCode: 'Postal Code',
    forJapanese: 'Mandatory for Japanese users'
  },
  pager: {
    total: 'Total',
    results: 'Results',
    searchResult: 'Search Result:'
  },
  concept: {
    new: 'New',
    old: 'Old',
    year: 'Year',
    addOldConcept: 'Add Old Concept',
    addNewConcept: 'Add New Concept',
    uploadPicture: 'Upload Picture',
    pictureRequire: 'Picture: (picture size require: 16:9)',
    fileRequire: 'Files: (picture size require: 16:9)',
    fileLimit: '*Only MP4 for video and PDF for documents is supported. MP4 < 50mb, PDF < 20mb',
    fileName: 'File Name',
    basfProductPrd: 'Basf Product Prd',
    basfProductName: 'Basf Product Name',
    approved: 'Approved',
    approval: 'Approval',
    pendingApproved: 'Pending Approve',
    denied: 'Denied',
    draft: 'Draft',
    country: 'Country',
    type: 'Type',
    segment: 'Segment',
    updateYear: 'Update Year',
    approver: 'Approver',
    submitBy: 'Submit By',
    newConcept: 'New Concept',
    search: 'Search',
    name: 'Name',
    regionCountry: 'Locations',
    rate: 'Rate',
    webView: 'Web View',
    appView: 'App View',
    set: 'Set',
    operation: 'Operation',
    approveTime: 'Approve Time',
    updateTime: 'Update Time',
    editOldConcept: 'Edit Old Concept',
    conceptName: 'ConceptName',
    conceptNameCn: 'Concept name(CN)',
    conceptNameEn: 'Concept name(EN)',
    conceptNameJp: 'Concept name(JP)',
    ownerName: 'Owner',
    ownerEmail: 'Owner email',
    oldFile: 'Old File',
    cancel: 'Cancel',
    submit: 'Submit',
    picture: 'Picture',
    language: 'Language',
    files: 'Files',
    uploadFile: 'Upload File',
    saveAsDraft: 'Save As Draft',
    next: 'Next',
    conceptPdf: 'Concept PDF',
    premiumTips: 'Club content will only open to DlitE3X Club user but not to DlitE3X Lite user (Free  version).',
    internalTips: 'Internal content will open only to DlitE3X internal users, but not to the DlitE3X external users.',
    conceptPdfPremium: 'Concept PDF (Club)',
    conceptPdfInternal: 'Concept PDF (Internal)',
    editNewConcept: 'Edit New Concept',
    information: 'Information',
    video: 'Video',
    videoPremium: 'Video (Club)',
    videoInternal: 'Video (Internal)',
    scientficDocumentPdf: 'Scientfic Document PDF',
    trendPdf: 'Trend PDF',
    consumerInsightPdf: 'Consumer Insight PDF',
    ClaimPerformance: 'Claim-Performance',
    back: 'Back',
    relatedFormulation: 'Related Formulation',
    relatedBasfProduct: 'Related BASF Product',
    preview: 'Preview',
    chooseFile: 'Choose File',
    change: 'Change',
    view: 'View',
    relatedClaims: 'Related Claims',
    formulationId: 'Formulation ID',
    trendTitle: 'Trend Title',
    formulationName: 'Formulation Name',
    relatedConcept: 'Related Concept',
    relatedConceptPremium: 'Related Concept (Club)',
    relatedConceptInternal: 'Related Concept (Internal)',
    relatedScientificDocument: 'Related Scientific Document',
    relatedTrend: 'Related Trend',
    relatedConsumerInsight: 'Related consumer insight',
    previous: 'Previous',
    antiAnce: 'Anti-Ance',
    approvalComment: 'Approval Comment',
    edit: 'Edit',
    withdraw: 'Withdraw',
    setNewConcept: 'Set New Concept',
    setToNewConcept: 'Set To New Concept',
    weight: 'Weight',
    notice: 'Notice',
    export: 'Export',
    selectClaim: 'please select a claim',
    selectFile: 'please select a file',
    userTips: 'Description: If you choose target user and user group, only the users you chosen can view this concept; otherwise everyone user can view this concept.',
    missPicOrName: 'Missing picture or picture name',
    missFileName: 'Filename is required',
    missFile: 'File is required',
    fileLang: 'File Language',
    languageTips: 'In which language setting will the concept be presented',
    top10BASFProduct: 'Top 10 BASF Product',
    top10Formulation: 'Top 10 Formulation',
    exportData: 'Export Data',
    underConstruction: 'Under construction',
    keyWord: 'Key word',
    location: 'Location',
    views: 'Views',
    relatedBASFFormulation: 'Related BASF Formulation',
    relatedPerformance: 'Claim/Related Performance',
    clickToView: 'Click to view',
    top10BASFProductFormulation: 'Top 10 BASF Product & Formulation',
    dlite3Pick: 'D’litE³™X’s Pick',
    specificUserOnly: 'Specific user only',
    enDescription: 'Description(EN)',
    cnDescription: 'Description(CN)',
    jpDescription: 'Description(JP)',
    relatedKalturaVideo: 'Related Kaltura Video',
    inputkalturaVideoTitle: 'Input kaltura Video title',
    conceptInternal: 'Concept (Internal)'
  },
  event: {
    NO: 'NO.',
    eventName: 'Event Name',
    eventStatus: 'Event Status',
    Type: 'Type',
    startDate: 'Start Time',
    endDate: 'End Time',
    Speaker: 'Speaker',
    Formulation: 'Formulation',
    BASFProductCategory: 'BASF Product Segment',
    BASFProduct: 'BASF Product',
    Solution: 'Solution',
    status: 'Status',
    Operation: 'Operation',
    View: 'view',
    Edit: 'Edit',
    Online: 'Online',
    Offline: 'Offline',
    QRCode: 'QR Code',
    export: 'Export data',
    AddNewEvent: 'Add New Event',
    speakername: 'Speaker Name',
    speakerpicture: 'Speaker Picture',
    spearkerTitle: 'Spearker Title',
    Weight: 'Order',
    SolutionName: 'Solution Name',
    SolutionFile: 'solution File',
    Clicks: 'Clicks',
    TimeAddress: 'Time & Address',
    ProductName: 'Product Name',
    ProductID: 'Product ID',
    OPPFile: 'OPP File',
    Category: 'Segment',
    Segment: 'Category',
    Ratings: 'Rate',
    FormulationName: 'Formulation Name',
    FormulationID: 'Formulation ID',
    MainPicture: 'Main Picture',
    FormulationFile: 'Formulation File',
    EventSegment: 'Event Segment',
    AddFormulationCategroy: 'Add Formulation Segment',
    FormulationCategory: 'Formulation Segment',
    CategoryPicture: 'Segment Picture',
    Editevent: 'Edit a event - Basic',
    Addevent: 'Add a event - Basic',
    Welcomewords: 'Welcome words',
    Eventkeyvisual: 'Event key visual',
    Time: 'Time',
    EditFormulation: 'Edit Formulation',
    AddFormulation: 'Add Formulation',
    SubCategory: 'Sub-Category',
    FunctionalClaim: 'Functional Claim',
    CommentKeyWords: 'Comment Key Words',
    Editformulationcategory: 'Edit Formulation Segment',
    Addformulationcategory: 'Add Formulation Segment',
    CategoryName: 'Segment Name',
    EditProduct: 'Edit BASF Product',
    AddProduct: 'Add BASF Product',
    BASFProductID: 'BASF Product ID',
    BASFProductName: 'BASF Product Name',
    BASFProductOPPFile: 'BASF Product OPP File',
    Claims: 'Claims',
    INCI: 'INCI',
    Formofdelivery: 'Form of delivery',
    ecostatus: 'Eco-status',
    Function: 'Function',
    EditBASFProductCategory: 'Edit BASF Product Segment',
    AddBASFProductCategory: 'Add BASF Product Segment',
    EditSolution: 'Edit Solution',
    AddSolution: 'Add Solution',
    Solutionname: 'Solution name',
    Picture: 'Picture',
    Solutionfile: 'Solution file',
    EditSpeaker: 'Edit Speaker',
    AddSpeaker: 'Add Speaker',
    SpeakerName: 'Speaker Name',
    SpeakerTitle: 'Speaker Title',
    SpeakerPicture: 'Speaker Picture',
    File: 'File',
    Venue: 'Venue',
    Organizer: 'Organizer',
    FormulationSegment: 'Formulation Segment',
    keyWordsMsg: 'Separate different key words by commas, please',
    Target: 'Target user',
    TargetGroup: 'Target user group',
    creator: 'creator',
    CreationTime: 'Creation Time',
    Modifier: 'Modifier',
    ChangeTheTime: 'Modified Time',
    Description: 'If you choose target user and user group, only the users you chosen can view this event; otherwise everyone user can view this event.',
    DescriptionSpan: 'Description',
    segmentPicture: 'Segment Picture',
    trend: 'Trend',
    trendName: 'Trend Name',
    addTrend: 'Add Trend',
    editTrend: 'Edit Trend',
    concept: 'Concept',
    conceptName: 'Concept Name',
    addConcept: 'Add Concept',
    editConcept: 'Edit Concept',
    title: 'Title',
    exportEventList: 'Export event list',
    exportParticipantData: 'Export participant data',
    exportVisitData: 'Export visit data',
    exportCommentData: 'Export comment data',
    exportDownloadData: 'Export download data',
    recommendedSize: 'Recommended size',
    recommendedRatio: 'Recommended ratio',
    kalturaVideo: 'Kaltura Video',
    selectDate: 'Select Date',
    selectTime: 'Select Time',
    orderTips: '( 0.0 - 100.0, The larger the value, the higher the display order )',
    clickToJump: 'User click to jump to',
    eventVideoAndSpeaker: 'Event (Video and Speaker)',
    allowPDFDownload: 'Allow PDF download',
    moduleSort: 'Module sort'
  },
  eventClient: {
    startTime: 'Start Time',
    upcoming: 'Upcoming',
    speakerInformation: 'Speaker Information',
    time: 'Time',
    venue: 'Venue',
    organizer: 'Organizer',
    relatedBASFProduct: 'BASF Product',
    relatedFormulation: 'Formulation',
    relatedConcept: 'Concept',
    relatedTrend: 'Trend',
    viewDetail: 'View Detail',
    viewPage: 'View Page',
    viewDocument: 'View Document',
    rateComment: 'Rate & Comment',
    claim: 'Claim',
    function: 'Function',
    inci: 'INCI',
    formOfDelivery: 'Form of Delivery',
    yourComment: 'Your comment',
    qustion1: 'How likely are you going to adapt this BASF Product?',
    qustion2: 'How likely are you going to adapt this Formulation?',
    qustion3: 'How much do you agree on these aspects this BASF Product?',
    qustion4: 'How much do you agree on these aspects this Formulation?',
    addNewAspect: 'Add new aspect to rate',
    newAspect: 'New aspect',
    writeYourComment: 'Write your comment'
  },
  account: {
    userId: 'User ID',
    account: 'Account (E-mail)',
    name: 'Name',
    title: 'Title',
    tel: 'Telephone',
    pass: 'Password',
    conPass: 'Confirm Password',
    role: 'Role',
    expert: 'Expert',
    status: 'Status',
    addAccount: 'Add New Account',
    editAccount: 'Edit Account',
    country: 'Locations',
    addRole: 'Add New Role',
    editRole: 'Edit Role',
    roleName: 'Role Name',
    download: 'Download',
    roleId: 'Role ID',
    roleAuth: 'Role Authority',
    downAuth: 'Download Authority (web)',
    BASFProductAuthority: 'BASF Product Detail Display Authority(web)',
    AppBASFProductAuthority: 'BASF Product Detail Display Authority(App)',
    withoutPermission: 'Without permission，Tick shows “ Upgrade to unlock this section”, No tick shows “Please contact your BASF Sales Representative for details”',
    noTickText: 'Please contact your BASF Sales Representative for details',
    userGroupName: 'User Group Name',
    addGroup: 'Add New Group',
    editGroup: 'Edit Group',
    user: 'Users',
    displayAuth: 'Display Authority (web)',
    userType: 'User Type',
    // sendMail: 'Notification Mail',
    sendMail: 'Send role-change email to user',
    tips: 'Tips',
    powerUser: 'Super User',
    company: 'Company',
    department: 'Department',
    fontEndManage: 'Web Front End',
    userManage: 'User & General Management',
    dataManage: 'Data Management',
    appManage: 'APP Front End',
    register: 'Register Time',
    superUserTip: 'Super user has full access rights on all data and would not be controlled by "target user restriction"',
    disabledGroup: '<span style="color: red;">Red</span> = Disabled user user group',
    userGroup: 'User Group',
    effectivePeriod: 'Role Effective Period',
    chooseExpiryDate: 'Choose expiry date',
    effectivePeriodTip: "When the expiry date is reached, Role will turn to the default free role<br>For example, if the expiry date is set for January 1, the user's role will turn to free after January 1, 23:59:59",
    expiryDate: 'Role Expiry Date',
    lastExpiredRole: 'Last Expired Role',
    expiry: 'Expiry Date',
    desc: 'Description to User',
    descTips: 'The content inputed in here will be displayed in the user center page in app, for user using this role.',
    viewAccount: 'View Account',
    deregistration: 'Deregistration',
    deregistrationStatus: 'Deregistration Status',
    deregistrationTitle: 'Account Deregistration',
    carefully: 'Please proceed cautiously！',
    deregistrationTips: 'After the account is cancelled, the following information will be cleared and cannot be retrieved.',
    carefully1: '• Account Access Information',
    carefully2: '• My Profile',
    carefully3: '• My Favorites',
    carefully4: '• My Order',
    deregistrationSure: 'Are you sure you want to <span style="color: #FF0000">Deregistrate</span> the account?',
    massSelect: 'Mass select',
    massTips: 'Please enter account E-mail, separated by ‘,’ or <span style="font-style:italic;">ENTER</span>, max input length is 2,500.',
    checkAccount: 'Check account',
    unMatched: 'UnMatched',
    matched: 'Matched',
    import: 'Import',
    undo: 'Undo',
    pleaseEnterAccount: 'Please enter account E-mail',
    exportPermissionList: 'Export permission list',
    exportRoleList: 'Export role list',
    selected: 'Selected',
    massAssignRoles: 'Mass Assign Roles',
    massEdit: 'Mass Edit Accounts',
    presetRole: 'Preset Role',
    massDeleteRoles: 'Mass Delete Roles',
    deleteFailedTips: 'Failed to delete user ID',
    registerAccount: 'Register and activate account',
    inactive: 'Inactive',
    activated: 'Actived',
    expired: 'Expired',
    customerCompany: 'Customer Company',
    customerGroup: 'Customer Group',
    userCompanyTips1: 'You can view a list of companies, and manage roles for user company and customer company, customer group, and user type',
    userCompanyTips2: 'Tip: Modifying the rules here will immediately modify all user profiles that meet the rules, please operate with caution',
    suffixTips: 'The system has detected that the following accounts have met your whitelist rules. Do you need to overwrite the following user information?',
    lastDisableTime: 'Last Disable Time',
    currentRole: 'Current Role',
    requestedAccess: 'Requested Access',
    randomPassword: 'Random Password'
  },
  basfProduct: {
    addBasfProduct: '+ Add BASF Product',
    valueProposition: 'Value Proposition',
    files: 'Files',
    specification: 'Specification',
    technicalInformation: 'Technical Information',
    statement: 'Statement',
    certificates: 'Certificates',
    marketingInformation: 'Marketing Information',
    marketingInformationPremium: 'Marketing Information (Club)',
    webAndApp: 'Web & App',
    webOnly: 'web only',
    changeStatusTitle: 'Are you sure to {current} the BASF Product below?',
    disable: 'DISABLE',
    enable: 'ENABLE',
    basfProductName: 'BASF Product Name',
    PRDNumber: 'PRD Number',
    keyFocusProduct: 'Highlights',
    requestDocumentation: 'Request Documentation',
    requestedTips: 'Your application is pending for approval',
    BASFProduct: 'BASF Product',
    email: 'Email',
    name: 'Name',
    company: 'Company',
    telephone: 'Telephone',
    additionalRequests: 'Additional requests for other products',
    otherProducts: 'Please state any other products or requests',
    submitSuccessfully: 'submit successfully',
    sampleRequest: 'Sample Request',
    telephoneIsRequired: 'Telephone is required',
    dataNoFound: 'Data no found',
    addCartSuccess: 'This product has been added into the shopping cart',
    submitSuccess: 'submit successfully',
    submitFailure: 'submit failure',
    addressIsRequire: 'Address is required',
    addCartText: 'Sample Request',
    languageLimitTrade: 'Sorry, this product is currently unavailable in this region.',
    toxAbstract: 'Tox Abstract: (Statements)'
  },
  exportResult: {
    start: 'Start',
    end: 'End',
    export1: 'You can only export',
    export2: 'records each time',
    compare: 'Start number can\'t bigger than end number',
    downloading: 'Downloading',
    downloadFail: 'Downloading failed',
    to: 'to'
  },
  relationship: {
    addForm: 'Add New Form',
    editForm: 'Edit Form',
    addApplication: 'Add New Application',
    editApplication: 'Edit Application',
    addBenefit: 'Add New Consumer Benefit',
    editBenefit: 'Edit Consumer Benefit',
    addGroup: 'Add New Product Group',
    editGroup: 'Edit Product Group',
    tradeName: 'Formulation Tradename',
    fucntion: 'Formulation Function',
    type: 'Type',
    relatedProduct: 'Related system BASF Product',
    relatedPrd: 'Related system BASF Product PRD',
    addCompetitor: 'Add BASF Competitor Product',
    editCompetitor: 'Edit BASF Competitor Product',
    competitorProduct: 'Product from other companies',
    productName: 'Competitor Product Name',
    companyName: 'Company Name',
    competitorName: 'Product Name from other companies',
    inci: 'INCI',
    relatedCompetitor: 'Related product from other companies',
    editClaim: 'Edit Claim',
    addFunction: 'Add New Function',
    editFunction: 'Edit Function',
    claimTips: 'You can management product claims here, add similar claims to each other.',
    productTips: 'You can manage the product extract form BASF formulations, distinguish them are BASF product or from other companies.',
    applicationTips: 'You can manage the BASF product application key words here.',
    deliveryTips: 'You can manage the BASF product form of delivery key words here.',
    benefitTips: 'You can manage the BASF product consumer benefit key words here.',
    groupTips: 'You can manage the BASF product main group key words here.',
    functionTips: 'You can manage the BASF Product function here.',
    brandClaimTips: 'You can manage brand claims here, add similar brand claims to each other.',
    BASFMarkTips: 'You can manually control the 【BASF】 mark for INCI here.',
    sourceName: 'Source',
    sourceForulationId: 'Source Formulation ID',
    dliteFunctionTips: "You can manage the D'litE Function here",
    dliteFunctionEn: "D'litE Function(EN)",
    dliteFunctionCn: "D'litE Function(CN)",
    dliteFunctionJp: "D'litE Function(JP)",
    dliteFunction: "D'litE Function",
    dliteFunctionExist: "D'litE function(EN) or D'litE function(CN) already exist",
    updateTime: 'Update time',
    basfFunction: 'Function',
    basfFunctionEn: 'BASF Product Function(EN)',
    basfFunctionCn: 'BASF Product Function(CN)',
    basfFunctionExist: "BASF Product function already exist/BASF Product(en) already exist",
    bevolFunctionTips: "You can manage the Bevol Function here",
    bevolFunctionEn: 'Bevol function',
    bevolFunctionCn: 'Bevol function (CN)',
    bevolFunctionJp: 'Bevol function (JP)',
    bevolFunctionStatus: 'Show as functional claim',
    matchingFunction: 'Matching D’litE Function',
    editBevolFunction: 'Edit Bevol function',
    basfFunctionJp: "BASF Product Function(JP)",
    deleteBenefitTips: 'Are you sure to delete this Consumer benefit?',
    benefitIsUseTips: 'BASF Product in the system contains this Consumer benefit, please cancel the association first',
    commentKeywords: {
      keyword: 'Keyword',
      translationEn: 'Translation(EN)',
      translationJp: 'Translation(JP)',
      startDate: 'Start Date',
      endDate: 'End Date',
      status: 'Status',
      createTime: 'Create Time',
      headerTips: 'You can manage the wordle in Consumer Products here',
      addKeyword: 'Add Keyword',
      editKeyword: 'Edit Keyword',
      massUpload: 'Mass Upload',
      uploadTips: 'Note: Changes made here will need one day to process and publicise',
      uploadTips2: 'Please use the exported file to upload the updated data.',
      uploadTips3: 'System will automatically download the upload result for you, or you can click the link below to download directly.',
      disableTips: 'Are you sure to disable it?',
      enableTips: 'Are you sure to enable it?',
      deleteTips: 'Are you sure you want to delete?',
      illegalID: 'Illegal ID',
      matching: 'Matching',
      translation: 'Translation',
      addTranslation: 'Add Translation',
      translationHeaderTips: 'You can manage the wordle translation in Consumer Products here',
      editMatching: 'Edit matching',
      BEVOLKeyword: 'BEVOL Keyword',
      matchingDlitE3XKeyword: 'Matching DlitE3X Keyword',
      type: 'Type',
      positive: 'Positive',
      negative: 'Negative',
      neutral: 'Neutral',
      dlitE3XKeyword: 'DlitE3X  Keyword',
      dlitE3XKeywordCn: 'DlitE3X  Keyword(CN)',
      dlitE3XKeywordJp: 'DlitE3X  Keyword(JP)',
      matchingBEVOLKeyword: 'Matching BEVOL Keyword',
      editTranslation: 'Edit Translation',
      keywordHasExist: 'Keyword has exist',
      DlitE3XKeywordIsNotEmpty: 'DlitE3X Keyword Is Not Empty'
    },
    claim: {
      matching: 'Matching',
      translation: 'Translation',
      addTranslation: 'Add Translation',
      translationTips: 'You can manage the claim translation in Consumer Products here',
      dlitE3XClaim: 'DlitE3X Claim',
      dlitE3XClaimCn: 'DlitE3X Claim(CN)',
      dlitE3XClaimJp: 'DlitE3X Claim(JP)',
      dlitE3XClaimKana: 'DlitE3X Claim kana(JP)',
      matchingBEVOLClaim: 'Matching BEVOL Claim',
      matchingBEVOLClaimIsNotEmpty: 'Matching BEVOL Claim Is Not Empty',
      similarClaim: 'Similar Claim',
      nameExist: 'This name has exist',
      createTime: 'Update Time',
      claim: 'Claim',
      note: 'Note: Changes made here will need one day to process and publicise',
      matchingTips: 'You can manage the claim in Consumer Products here',
      editMatching: 'Edit matching',
      editTranslation: 'Edit Translation',
      matchingDlitE3XClaim: 'Matching DlitE3X Claim',
      BEVOLClaim: 'BEVOL Claim',
      isNotEmpty: 'DlitE3X Claim Is Not Empty'
    }
  },
  aboutBASF: {
    addContactor: 'Add New Contactor',
    contactorName: 'Contactor Name',
    email: 'E-mail',
    expert: 'Expert',
    search: 'Search',
    yes: 'Yes',
    no: 'No',
    contactorPicture: 'Contactor Picture',
    title: 'Title',
    introductionDocument: 'Introduction Document',
    weight: 'Weight',
    operation: 'Operation',
    uploadDocument: 'Upload Introduction Document',
    addAboutBASF: 'Add Contactor',
    editAboutBASF: 'Edit Contactor'
  },
  appPictures: {
    moduleMainPicture: 'APP Module Main Picture',
    banner: 'APP Banner',
    openScreen: 'APP Open screen',
    position: 'Position',
    picture: 'Picture',
    link: 'Link',
    longImage: 'Long image',
    addBanner: 'Add New Banner',
    languageTips: 'In which language setting will the banner be presented'
  },
  messageModule: {
    number: 'NO.',
    sendMessage: 'Send New Message',
    viewMessage: 'View Message',
    title: 'Title',
    date: 'Sent Date',
    sender: 'Sender',
    content: 'Content',
    recipient: 'Recipient',
    recipientUser: 'Recipient User',
    recipientGroup: 'Recipient Group',
    messageType: 'Message Type',
    start: 'Start  Date',
    end: 'End Date',
    receiver: 'Receiver'
  },
  messageCenter: {
    messageCenter: 'Message Center',
    viewDetail: 'View detail',
    sender: 'Sender',
    message: 'Message',
    messageDataOwner: 'Message to data owner of {name}',
    messageType: 'Message Type',
    title: 'Title',
    start: 'Start Date',
    end: 'End Date',
    total1: 'Total',
    total2: 'records',
    systemAutomatic: 'System',
    manual: 'Manual',
    recipient: 'recipient'
  },
  coowner: {
    group: 'Please select Co-owner role',
    supportUserGroup: 'Please select technical support message role',
    securityUserGroupId: 'Please select security role',
    general: 'General',
    customerContact: 'Customer contact',
    account: 'Account',
    addCustomerContact: 'Add Customer contact',
    editCustomerContact: 'Edit Customer contact',
    requiredLocations: 'Locations is required',
    selectRole: 'Please select role',
    maximumRole: 'A maximum of  5 roles can be added.',
    selectAccount: 'Please select Account',
    maximumAccount: 'A maximum of 10 accounts can be added.',
    red: 'Red',
    disabledTips: 'Disabled user account/role',
    remarks: 'Remarks',
    emptyTips: 'Both role and account cannot be empty',
    customerFeedback: 'Please set user to receive customer feedback'
  },
  activityLog: {
    userId: 'User ID',
    userName: 'User Name',
    userAccount: 'User Account',
    action: 'Action',
    contentTitle: 'Content Title',
    module: 'Module',
    documentRequest: 'Document Request',
    download: 'Download',
    dataUpdate: 'Data Update',
    accessRights: 'Access Rights',
    activityID: 'Activity ID',
    actionTime: 'Action Time',
    sectionPage: 'Section / Page',
    targetPage: 'Target Page',
    tabName: 'Tab Name',
    downloadAmount: 'Download Amount'
  },
  whiteList: {
    company: 'Company',
    account: 'Account(E-mail)',
    role: 'Role',
    group: 'User group',
    registerStatus: 'Register status',
    userType: 'User type',
    accountTips: 'Please make sure this is the e-mail user uses to register, When adding multiple accounts, separate them with “,”.',
    domainTips: 'Please make sure this is the domain mail, When adding multiple domain mail, separate them with “,”(for example：@basf.com,@partners.basf.com)',
    maxAccount: 'Maximum of 30 accounts can be added at one time',
    maxDomain: 'Maximum of 30 Domain mail can be added at one time',
    alreadyAccount: 'Following accounts already exist and cannot be added repeatedly',
    alreadyDomain: 'Following Domain mail already exist and cannot be added repeatedly',
    emailError: 'Illegal Account(E-mail) address',
    repeatedlyAccount: 'Following accounts were entered repeatedly',
    repeatedlyDomain: 'Following Domain mail were entered repeatedly',
    roleEffectivePeriod: 'Role Effective Period',
    yes: 'Yes',
    no: 'No',
    Days: 'Days',
    userTypeLabel: 'User Type for all the account(s)',
    remark: 'Remarks',
    addWhiteList: 'Add New White List',
    editWhiteList: 'Edit White List',
    selected: 'Selected',
    massAssignRoles: 'Mass Assign Roles',
    massEdit: 'Mass Edit',
    presetRole: 'Preset Role',
    massDeleteRoles: 'Mass Delete Roles',
    massEditWhiteList: 'Mass Edit WhiteList',
    personalMail: 'Personal mail',
    domainMail: 'Domain mail',
    registeredAccountAmount: 'Registered account amount',
    registeredAccount: 'Registered Account',
    registerTime: 'Register Time',
    close: 'Close',
    domainMailTips: 'Please make sure this is the domain mail (for example:@basf.com)',
    customerCompanyTips: 'Customer Company ({current}) Exists',
    scource: 'Source',
    userRegistration: 'User',
    whiteList: 'Admin',
    customerCompany: 'Customer Company',
    viewListTips: 'You can view a list of companies, and manage roles for user company and customer company, customer group, and user type',
    editTips: 'Tip: Modifying the rules here will immediately modify all user profiles that meet the rules, please operate with caution',
    editCustomerCompanyTitle: 'Edit Customer Company',
    customerCompanyAndGroup: 'Customer Company and Group',
    companyHasExist: 'Customer Company has exist',
    addToSelected: 'Add to selected',
    customerCompanyAndGroupRequired: 'Please add customer company and group from the left',
    selectedBtn: 'Selected'
  },
  blackList: {
    addBlackList: 'Add New Blacklist',
    editBlackList: 'Edit Blacklist',
    setUserType: 'Set User Type',
    userTypeTips: 'After the user registers an account successfully, if the mailbox matches the rule, the user type will automatically become the selected type, and the account status will automatically become disabled'
  },
  inciManagement: {
    massUpdate: 'Upload to mass update',
    uploadTips1: '* Please use the exported file to upload the updated data, when adding multiple data, separate them with ",".',
    uploadTips2: '* A maximum of 3000 records can be uploaded each time.',
    verifyTips: 'Verify uploaded results',
    verifyTips1: '* System will only handle the Function(manual setting) and Functional Claim(manual setting) columns in your upload file.',
    verifyTips2: '* If uploaded data does not recognized by system, the INCI Name will be marked in <span style="color: #FF0000">red</span>, you can check and adjust it in the result list.',
    pleaseUpload: 'Please upload your file first',
    functionManual: 'Function(manual setting)',
    claimManual: 'Functional Claim(manual setting)',
    submitUpdate: 'Submit and Update',
    uploadItem: 'Uploaded item',
    failedItem: 'Unrecognized item',
    inciName: 'INCI Name',
    inciNameDisplayed: 'INCI Name Displayed',
    casNum: 'CAS Number',
    releaseRegion: 'Release Locations',
    releaseRegionManual: 'Release Locations (Manual setting)',
    functional: 'Function',
    functionClaim: 'Functional Claim',
    bMark: 'BASF Mark',
    uploadFailed: 'Upload failed, please upload the required Excel file',
    inciNameEn: 'INCI Name(EN)',
    inciNameCn: 'INCI Name(CN)',
    inciNameJp: 'INCI Name(JP)',
    qdNameJp: 'QD Name(JP)',
    inciNameDisplayedEn: 'INCI Name Displayed (EN)',
    inciNameDisplayedCn: 'INCI Name Displayed (CN)',
    inciNameDisplayedJp: 'INCI Name Displayed (JP)',
    inciNameDisplayedEnTips: 'INCI name displayed(EN) already exist',
    inciNameDisplayedCnTips: 'INCI name displayed(CN) already exist',
    inciNameDisplayedJpTips: 'INCI name displayed(JP) already exist',
    functionClaimOriginal: 'Functional Claim (Original)',
    qdNameIsNotEmpty: 'QD Name is Not Empty'
  },
  userBehavior: {
    countryDisTitle: 'User Country/Region Distribution',
    typeDisTitle: 'User Type Distribution',
    departmentDisTitle: 'User Department Distribution',
    country: 'Country/Region',
    userNum: 'Number of User',
    rate: 'Rate',
    userType: 'User Type',
    department: 'Department',
    newUser: 'New User',
    newUserYesterday: 'New User (Yesterday)',
    newUserLastWeek: 'New User (Last week)',
    newUserLastMonth: 'New User (Last month)',
    activeUser: 'Active User',
    activationAnalysis: 'Acquisition and Activation Analysis',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last3Months: 'Last 3 Months',
    dailyActiveUser: 'Daily Active User (Average in last 30 days)',
    weeklyActiveUser: 'Weekly Active User (Last week)',
    monthlyActiveUser: 'Monthly Active User (Last month)',
    activeDay: 'Active Day',
    weekAverageActiveDay: 'Week Average Active Day (Last week)',
    monthAverageActiveDay: 'Month Average Active Day (Last month)',
    onlineTime: 'Online Time',
    dailyAverageOnlineTimeYesterday: 'Daily Average Online Time (Yesterday)',
    dailyAverageOnlineTimeWeek: 'Daily Average Online Time (Last week)',
    dailyAverageOnlineTimeMonth: 'Daily Average Online Time (Last month)',
    visitedPage: 'Visited Page',
    averageVisitedPageYestoday: 'Average Visited Page (Yesterday)',
    averageVisitedPageWeek: 'Average Visited Page (Last week)',
    averageVisitedPageMonth: 'Average Visited Page (Last month)',
    mostlyVisited: 'Top 10 mostly visited',
    yesterday: 'Yesterday',
    newUserRetention: 'Retention Analysis of New User',
    moduleClickAnalysis: 'Module Click Analysis of App',
    clickOfPage: 'Click of Home page',
    clickOfPageTips: 'Rate = click of module/sum of click of each module',
    searchOfPage: 'Click of Search Page',
    searchOfPageTips: 'Rate = click of module/sum of click of each module',
    days: 'days',
    day: 'day',
    newUserLabel: 'New User',
    activeUserLabel: 'Active User',
    userCount: 'User Count',
    databaseBasicData: 'Database basic data',
    visitData: 'Visit data',
    hitData: 'Hit data',
    maxTimeRangTips: 'The maximum selectable time frame is 31 days. The selected time frame exceeds the maximum limit, please select again.',
    totalRecord: 'Total Record:',
    EachTime5000: 'You can only export no more than 50,000 records each time.',
    EachTime31: 'The maximum selectable time frame is 31 days. The selected time frame exceeds the maximum limit, please select again.',
    timePeriodNewUser: 'Time Period New User<br>({current})',
    timePeriodActiveUser: 'Time Period Active User<br>({current})',
    newUserYesterdayTips: 'New User (Yesterday): Users who registered from 0:00 to 24:00 yesterday',
    newUserLastWeekTips: 'New User (Last week): Users who registered from last Monday 0:00 to last Sunday 24:00',
    newUserLastMonthTips: 'New User (Last month): Users who registered from 0:00 on the first day to 24:00 on the last day of last month',
    timePeriodNewUserTips: 'Time Period New User (YYYY-MM-DD-YYYY-MM-DD): Users who registered from 0:00 to 24:00 during selected time',
    dailyActiveUserTips: 'Daily Active User (Average in last 30 days): Total number of active users in the latest 30 days (user ID deduplication) / 30',
    weeklyActiveUserTips: 'Weekly Active User (Last week): Total number of active users from 0:00 last Monday to 24:00 last Sunday (user ID deduplication)',
    monthlyActiveUserTips: 'Monthly Active User (Last month): Total number of active users from 0:00 on the first day to 24:00 on the last day of last month (user ID deduplication)',
    timePeriodActiveUserTips: 'Time Period Active User (YYYY-MM-DD-YYYY-MM-DD): Total number of active users from 0:00 to 24:00 during selected time (user ID deduplication)',
    timePeriodActiveDay: 'Time Period Average Active Day<br>({current})',
    weekAverageActiveDayTips: 'Weekly Average Active Day (Last week): Total active days from last Monday 0:00 to last Sunday 24:00 / Total number of Active Users (user ID deduplication) <br>For example: There were two active users A and B last week. A was active for 3 days and B was active for 5 days, so weekly average active day was 4 days.',
    monthAverageActiveDayTips: 'Monthly Average Active Day (Last month): Total active days from 0:00 on the first day to 24:00 on the last day of last month / Total number of Active Users (user ID deduplication)',
    timePeriodActiveDayTips: 'Time Period Average Active Day (YYYY-MM-DD-YYYY-MM-DD): Total active days from 0:00 to 24:00 during selected time / Total number of Active Users (user ID deduplication) ',
    timePeriodOnlineTime: 'Daily Average Online Time<br>({current})',
    dailyAverageOnlineTimeYesterdayTips: 'Daily Average Online Time (Yesterday):Online Time of all users who met the filtering criteria from 0:00 to 24:00 yesterday / the total number of users who met the filtering criteria (user ID deduplication)',
    dailyAverageOnlineTimeWeekTips: 'Daily Average Online Time (Last week): Online Time of all users who met the filtering criteria from 0:00 last Monday to 24:00 last Sunday / the total number of users who met the filtering criteria (user ID deduplication)',
    dailyAverageOnlineTimeMonthTips: 'Daily Average Online Time (Last month): Online Time of all users who met the filtering criteria from 0:00 on the first day to 24:00 on the last day of last month / the total number of users who met the filtering criteria (user ID deduplication)',
    timePeriodOnlineTimeTips: 'Daily Average Online Time (YYYY-MM-DD-YYYY-MM-DD):Online Time of all users who met the filtering criteria from 0:00 to 24:00 during selected time / Number of users who met the filtering criteria (user ID deduplication)',
    timePeriodVisitedPage: 'Average Visited Page<br>({current})',
    averageVisitedPageYestodayTips: 'Average Visited Page (Yesterday): The number of pages visited by all users meeting the filtering criteria / the total number of users meeting the filtering conditions(user ID deduplication)',
    averageVisitedPageWeekTips: 'Average Visited Page (Last week): The number of pages visited by all users meeting the filtering criteria from 0:00 last Monday to 24:00 last Sunday/the total number of users meeting the filtering conditions(user ID deduplication)',
    averageVisitedPageMonthTips: 'Average Visited Page (Last month): The number of pages visited by all users meeting the filtering criteria from 0:00 on 1st of last month to 24:00 on 31st of last month / the total number of users meeting the filtering conditions(user ID deduplication)',
    timePeriodVisitedPageTips: 'Average Visited Page (YYYY-MM-DD-YYYY-MM-DD): The number of pages visited by all users meeting the filtering criteria from 0 to 24 in a certain period / the total number of users meeting the filtering conditions(user ID deduplication)',
    mostlyVisitedTips: 'Display the top 10 modules with the most PV<br>Display the top 10 content titles accessed by the selected module',
    newUserRetentionTips: 'Retention rate of new users (day): (number of active users on day X after registration / number of new registered users) *100%<br>For example: 2021-10-18 registered user Retention Rate(The 2nd day) = (2021-10-19 active users who register on 18th / 2021-10-18 registered users ) *100%<br><br>Retention rate of new users (week): (number of active users in week X after registration / number of new registered users) *100%<br>For example: Retention rate of registered users from 2022-1-3 to 2022-1-9 = (Number of active users from 2022-1-10 to 2022-1-16 who registered from 2022-1-3 to 2022-1-9 / number of registered users dfrom 2022-1-3 to 2022-1-9) *100%<br><br>Retention rate of new users (month): (number of active users in X month after registration/number of new registered users) *100%<br>For example: Retention rate of registered users in 2021-10(The 2nd month) = Number of active users in Nov who registered in Oct / Number of registered users in Oct) *100%'
  },
  register: {
    register: 'Register',
    email: 'E-mail',
    emailTips: 'Please use your company email',
    verificationCode: 'Verification code',
    getCode: 'Get code via email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    company: 'Company',
    department: 'Department',
    phone: 'Mobile phone',
    name: 'Name',
    locations: 'Locations',
    success: 'Registered successfully',
    placeholder: {
      email: 'Your E-mail',
      verificationCode: 'Your Verification code',
      password: 'Your Password',
      company: 'Your Company',
      department: 'Your Department',
      phone: 'Your Mobile phone',
      name: 'Your Name',
      locations: 'Your Locations'
    },
    SendActivationEmail: 'Send activation email',
    emainExists: 'The account {current} already exists, please log in to continue',
    existsTips: 'If you forget your password, please click “Forget Password” to reset',
    registerSuccessTips1: 'Registration Successful！',
    registerSuccessTips2: 'We have sent an activation email to your email {current},  Please click the link in the email to activate your account.',
    registerSuccessTips3: 'If you did not receive an activation email, please contact us at {current}',
    registerPendingTips1: 'A verification email has been sent to {current}',
    registerPendingTips2: 'Didn’t receive the email?',
    registerPendingTips3: 'Resend activation email',
    mobilePhone: 'Mobile phone',
    registerStatus: 'Register Status',
    activate: 'Activate',
    activateTips: 'Are you sure you want to activate the account？',
    activationSuccessful: 'Activation Successful',
    emailExist: 'This email has exist',
    emailRegistered: 'The email address has been registered and is waiting to be activated',
    emailSendSuccess: 'succeeded to send email',
    submitSuccess: 'submit successfully',
    submitFailure: 'submit failure',
    emailNotExist: 'The account does not exist, Please register again',
    emailHasExist: 'The account already exists, Please log in to continue',
    emailExpired: 'The account activation time has expired, Please register again'
  },
  homePage: {
    lastUpdate: 'Latest Updated',
    latestUpdate: 'Latest Update',
    mostView: 'Most Viewed',
    highLight: 'Highlights',
    noAccessTips: 'Sorry, you have no access to detail.',
    unlockTips: 'Upgrade to unlock this section',
    tips: 'Tips',
    goPremium: 'Go Premium!',
    upgrade: 'Upgrade to',
    clubMember: 'D’litE<sup style="vertical-align: super;">3</sup>X Club Member',
    toUnlock: 'to unlock valuable data.',
    bigDataAnalytics: 'Big Data Analytics',
    consumerInsights: 'Market-oriented Consumer Insights',
    premiumDocuments: 'Premium Documents',
    account: 'Account(e-mail)',
    company: 'Company',
    country: 'Country',
    clickTips: 'Click the button below to submit your application. You may edit your personal information in your profile',
    recommendTips: 'We highly recommend you to use company email applying for upgrade, or we may decline the application with private email. ',
    applyForUpgrade: 'Apply for upgrade',
    contactTips: 'In special cases, please contact your BASF representatives for more information.',
    thanks: 'Thank you for your interest in D’litE3X Club. Your application is now under the approval process.',
    unsuccessfulTips: 'Please contact sales personnel or below email address <a style="color: #007F42" target="_blank" href="mailto:CS.DlitE3-X@basf.com">CS.DlitE3-X@basf.com</a>, if  you don‘t hear from us in 1 month. Thank you.',
    year: 'Year',
    locantion: 'Locations',
    basfProduct: 'BASF Product',
    trend: 'Trend',
    concept: 'Concept',
    newUnlockTips: 'Internal Access Only',
    subscriptionTips: 'Please contact your BASF Sales Representative for details',
    goClub: {
      goClub: 'Go Club!',
      upgradeTo: 'Upgrade to <span>D’litE<sup style="vertical-align: super;">3</sup>X Club Member</span> to unlock valuable data',
      tips1: 'Market-oriented Consumer Insights and Analysis',
      tips2: 'Club Exclusive Documentations',
      processTips: 'It takes 7 days to process your request. You will be informed of the result through email.',
      thanks: 'Thank you for your interest in D’litE3X Club. Your application is now under the approval process.'
    },
    goPremiumObj: {
      goPremium: 'Go Premium!',
      subscribeTo: 'Subscribe to <span>D’litE<sup style="vertical-align: super;">3</sup>X Premium Membership</span> to unlock valuable data',
      tips1: 'Big Data Analytics',
      tips2: 'Global Market and Consumer Insights',
      tips3: 'BASF exclusive Chemical Data and Digital Tools',
      processTips: 'Your request will be submitted to the local sales representative. If you do not receive a reply within 10 working days, please contact Customer Service (CS.DlitE3-X@basf.com) for assistance.',
      applyForSubscribe: 'Apply for subscribe',
      thanks: 'Thank you for your interest in D’litE3X Premium. Your application is now under the approval process.'
    }
  },
  search: {
    moreBrands: 'More brands',
    moreProducts: 'More products',
    moreIngredients: 'More ingredients',
    moreBASFProducts: 'More BASF Products',
    moreTrends: 'More Trends',
    moreFormulations: 'More formulations',
    moreDocument: 'More document',
    moreConcept: 'More concept',
    moreVideo: 'More video',
    searchDlitE3X: 'Search D\'litE3X',
    searchBrand: 'Search Brand',
    searchProducts: 'Search Products',
    searchFormulation: 'Search Formulation',
    searchIngredient: 'Search Ingredient',
    searchBASFProduct: 'Search BASF Product',
    searchConcept: 'Search Concept',
    searchTrend: 'Search Trend',
    searchVideo: 'Search Video',
    searchDocuments: 'Search Documents',
    searchEvent: 'Search Event'
  },
  EcoStatusMap: {
    BASFNatural: 'From 100% natural, renewable feedstocks; Physically purified by water/achohol or energy.',
    BASFNaturalModified: 'From 100% natural, renewable feedstocks; Chemically processed, catalyst or reaction aids used.',
    BASFEcohybrids: 'From 100% natural, renewable & synthetic feedstocks; Renewable & synthetic building blocks are combined in a chemical process. Share nature C-atoms > 70%.',
    BASFHybrids: 'From 100% natural, renewable & synthetic feedstocks; Renewable & synthetic building blocks are combined in a chemical process. Share nature C-atoms < 70%.',
    BASFSynthetics: 'From synthetic feedstocks; Chemically processed.',
    BASFInorganics: 'From inorganic feedstocks',
    BASFAnimals: 'From animal feedstocks',
    title: {
      BASFNatural: 'BASF Natural',
      BASFNaturalModified: 'BASF Natural modified',
      BASFEcohybrids: 'BASF Ecohybrids',
      BASFHybrids: 'BASF Hybrids',
      BASFSynthetics: 'BASF Synthetics',
      BASFInorganics: 'BASF Inorganics',
      BASFAnimals: 'BASF Animals'
    }
  },
  media: {
    description: 'Description',
    select: 'Select',
    relatedVideo: 'Related Video',
    inputVideoTitle: 'Input Video title',
    addVideo: 'Add Video',
    relatedEvent: 'Related Event',
    relatedWebinar: 'Related Webinar',
    transcodedTips: 'The video is being transcoded, please wait patiently'
  },
  orderList: {
    additionalRequests: 'Additional Requests',
    time: 'Time',
    CoownerRole: 'Co-owner Role',
    CoownerAccount: 'Co-owner Account',
    View: 'View',
    requestList: 'Request List'
  },
  consumerProducts: {
    productList: 'Product List',
    briefAnalysis: 'Brief Analysis',
    brand: 'Brand',
    brandName: 'Brand Name',
    category: 'Category',
    claims: 'Claims',
    productForm: 'Product Form',
    productAspect: 'Product Aspect',
    sunscreenLevelSPF: 'Sunscreen Level-SPF',
    sunscreenLevelPA: 'Sunscreen Level-PA',
    includedINCI: 'Included INCI',
    excludedINCI: 'Excluded INCI',
    priceRange: 'Price Range',
    price: 'Price',
    launchYear: 'Launch Year',
    year: 'Year',
    sortBy: 'Sort by',
    export: 'Export',
    default: 'Default',
    click: 'Click',
    favorite: 'Favorite',
    comment: 'Comment',
    updateTime: 'Update Time',
    capacity: 'Capacity',
    claim: 'Claim',
    mainIngredients: 'Main ingredients',
    benchmarkFormulation: 'Benchmark Formulation',
    top10ClaimsProductForm: 'Top 10 Claims&Product Form',
    top10ClaimsSubCategory: 'Top 10 Claims&Sub-category',
    top10ProductsProductForm: 'Top 10 products distribution by Claim&Product Form',
    top10ProductsSubCategory: 'Top 10 products distribution by Claim&Sub-category',
    brandPositioning: 'Brand Positioning',
    pricePositioning: 'Price Positioning',
    market: 'Market',
    brandGroup: 'Brand Group',
    manufacture: 'Manufacture',
    subCategory: 'Sub-Category',
    dataFromCFDA: 'Data from NMPA',
    CFDARegistrationYear: 'NMPA Registration year',
    applicationArea: 'Application Area',
    packaging: 'Packaging',
    clicks: 'Clicks',
    topTips1: 'Top {current} amongst all products in the {quarter}',
    topTips2: 'Top {current} amongst products of this category in the {quarter}',
    similarFormulationProduct: 'Similar formulation & product',
    formulationWithSimilarClaim: 'Formulation with similar claim',
    FormulationThatYoMayAlsoLike: 'Formulation(s) that you may also like',
    relatedBASFProduct: 'Related BASF Product',
    productsOfSameBrand: 'Products of same brand',
    feedbackAnalysis: 'Feedback analysis',
    scoring: 'Scoring',
    reviews: 'Reviews',
    location: 'Location',
    province: 'Province',
    clicksRate: 'Clicks Rate',
    commentsRate: 'Comments Rate',
    top20Comments: 'Top 20 comments',
    consumerInsight: 'Consumer insight',
    skinType: 'Skin type',
    age: 'Age',
    clickDistribution: 'Clicks',
    allDataRelated: 'All data related to clicks start from April 2018.',
    notAnswered: 'Not Answered',
    youMayBeInterestedIn: 'You may be interested in',
    brandSearch: 'Brand Search',
    claimsForm: 'Claims/Form',
    claimsSubCategory: 'Claims/Sub-category',
    searchResult: 'Search Result',
    showMoreThan: 'show 10,000 records if the total record more than 10,000.',
    chartTips: 'Number of clicks (percentage of total users)',
    positive: 'Positive',
    negative: 'Negative',
    neutral: 'Neutral',
    top20Commentkeywords: 'Top 20 Comment keywords',
    clickToExploreSentiments: 'Click to explore sentiments',
    sentimentBreakdownOfKeyword: 'Sentiment Breakdown of Keyword',
    feedbackAnalysisTips: 'Percentage of consumer scoring in total reviews',
    locationTips: 'Number of comments and ratio from consumers by provinces in China',
    clickDistributionTips: 'Monthly number of clicks by consumers',
    locationClickTips: 'Number of clicks and ratio from consumers by provinces in China'
  },
  myProfile: {
    lastName: 'Last Name',
    firstName: 'First Name',
    pleaseUpdateYourNamingInformation: 'Please update your naming information',
    proceedToUpdate: 'Proceed to update',
    tips: 'Tips',
    avatar: 'Avatar',
    phone: 'Phone',
    emailAddress: 'E-mail address',
    company: 'Company',
    department: 'Department',
    locations: 'Locations',
    setPassword: 'Set Password',
    changePassword: 'Change Password',
    securitySetting: 'Security Setting',
    accountDeregistration: 'Account Deregistration',
    edit: 'Edit',
    editProfile: 'Edit Profile',
    changeAvatar: 'Change Avatar',
    imgTips: 'Only JPG/JPEG for avatar is supported. Size < 2mb',
    yourLastName: 'Your Last name',
    yourFirstName: 'Your First name',
    yourMobilePhone: 'Your Mobile phone',
    yourCompany: 'Your Company',
    yourDepartment: 'Your Department',
    yourLocations: 'Your Locations',
    save: 'Save',
    pleaseProceedCautiously: 'Please proceed cautiously!',
    cancelledTips: 'After the account is cancelled, the following information will be cleared and cannot be retrieved.',
    accountAccessInformation: 'Account Access Information',
    myProfile: 'My Profile',
    myFavorites: 'My Favorites',
    myOrder: 'My Order',
    cancelledHandlerTips: 'Please click the button below to apply for deregistration, or contact us via e-mail: ',
    applyForDeregistration: 'Apply for Deregistration',
    pendingApprovalTips: 'Your application is pending approval.',
    applyTime: 'Apply time: ',
    applySuccess: 'Apply success',
    emailTips: 'If you have any questions, please contact us via e-mail: ',
    getCode: 'Get verification code',
    verificationCode: 'Verification code'
  },
  formulationClient: {
    category: 'Category',
    claims: 'Claims',
    productForm: 'Product Form',
    productAspect: 'Product Aspect',
    sunscreenLevelSPF: 'Sunscreen Level-SPF',
    sunscreenLevelPA: 'Sunscreen Level-PA',
    includedINCI: 'Included INCI',
    excludedINCI: 'Excluded INCI',
    includeBasfProduct: 'Included BASF Product',
    excludeBasfProduct: 'Excluded BASF Product',
    tags: 'Tags',
    benchmarkProducts: ' Benchmark Products',
    subCategory: 'Sub-Category',
    laboratoryCountry: 'Laboratory Country',
    applicationArea: 'Application area',
    subApplicationArea: 'Sub-Application area',
    specificPopulationGroups: 'Specific Population Groups',
    priceRange: 'Price Range',
    formulationID: 'Formulation ID',
    updateYear: 'Update Year',
    owner: 'Owner',
    functionalClaim: 'Functional Claim',
    description: 'Description',
    downloadFormulationPDF: 'Download Formulation PDF',
    downloadAsPDF: 'Download as PDF',
    others: 'Others',
    ingredients: 'Ingredients',
    phase: 'Phase',
    BASFProduct: 'BASF Product',
    ecoStatus: 'Eco Status',
    INCIName: 'INCI Name',
    byWeight: '% by Weight',
    function: 'Function',
    specifications: 'Specifications',
    performance: 'Performance',
    manufacturingProcess: 'Manufacturing Process',
    downloadTips: 'This formulation is available as a {current} PDF download:',
    downloadBtnText: 'Download the formulation in {current} PDF',
    chinese: 'Chinese',
    japanese: 'Japanese',
    english: 'English',
    similarFormulation: 'Formulation with similar claim',
    interestFormulation: 'Formulation(s) that you may also like',
    KeyBASFProduct: 'Key BASF Product',
    relatedConcept: 'Related Concept',
    top10Products: 'Top 10 Benchmark Products'
  },
  agreementDialog: {
    title: 'User Agreement and Privacy Policy',
    row1: 'Please be sure to carefully read and fully understand each term of “Users’ Protocols”, including but not being limited to',
    row2: '(1) “Privacy Policy” concerning instructions on users’ information and usage of personal devices.',
    row3: '(2) “Privacy Policy” concerning instructions on data sharing, information collection and usage for the Third Party of SDK service providers.',
    row4: 'You may read “{agreement}” and “{policy}” to know the detailed information. If you agree with it, please click “Agree” to accept our service.',
    agree: 'Agree',
    exit: 'Exit'
  },
  brandClient: {
    brandList: 'Brand List',
    marketOpportunity: 'Market Opportunity',
    brandGroup: 'Brand Group',
    category: 'Category',
    claims: 'Claims',
    origin: 'Brand Origin',
    brandPositioning: 'Brand Positioning',
    pricePositioning: 'Price Positioning',
    segment: 'Segment',
    year: 'Year',
    country: 'Country',
    brandPositioningMap: 'Brand Positioning Map </br>(Retail Value & Growth Rate)',
    brandsClaims: 'Brands Claims&Category Distribution',
    brandsCount: 'Brands Count',
    T10CCP: 'Top 10 Claims & Category',
    retailValue: 'Retail Value',
    marketShare: 'Market Share',
    growthRate: 'Growth Rate',
    productAmount: 'Product Amount',
    officialLink: 'Official Link',
    majorProductCategory: 'Major Product Category',
    majorProductSubCategory: 'Major Product Sub-category',
    description: 'Description',
    claimsProducts: 'Claims & Products',
    ingredients: 'Ingredients',
    consumerInsight: 'Consumer Insight',
    consumerInsightChina: 'Consumer Insight China',
    marketData: 'Market Data',
    productsCount: 'Products Count',
    top5ClaimsTips: 'Default the top 5 claims among products launched in latest 6 years',
    allProducts: 'All Products',
    suggestedformulation: 'Suggested formulation by popular claims',
    moreformulation: 'More formulation by major product sub-category',
    subCategory: 'Sub-Category',
    function: 'Function',
    functionalClaim: 'Functional Claim',
    skinType: 'Skin type',
    age: 'Age',
    relatedBasfProduct: 'Related BASF Product',
    clicks: 'Clicks',
    clicksTips: 'All data related to clicks start from April 2018.',
    location: 'Location',
    province: 'Province',
    click: 'Click',
    clicksRate: 'Clicks Rate',
    commentsRate: 'Comments Rate',
    comment: 'Comment',
    comments: 'Comments',
    commentsCount: 'Comments Count',
    groupBrand: 'Group Brand',
    claimsCategory: 'Claims/Category',
    ingredientUsingTrend: 'Ingredient Using Trend',
    productName: 'Product name',
    categories: 'Categories',
    favorite: 'Favorite',
    commentScore: 'Comment Score',
    commentNum: 'Comment',
    rateTips: 'Rate=Products containing this ingredient/All products by filter',
    rate: 'Rate',
    BASFHas: 'BASF has this ingredient',
    number: 'Number',
    yearlyLaunchedProducts: 'Yearly launched products',
    clickCount: 'Click Count',
    topTips: 'Top {current} amongst all brands in the {quarter}',
    brandsUnderSameGroup: 'Brands Under Same Group',
    marketCountry: 'Market Country'
  },
  ingredientClient: {
    function: 'Function',
    functionalClaim: 'Functional Claim',
    releaseLocations: 'Release Locations',
    productCategory: 'Product Category',
    productSubCategory: 'Product Sub-Category',
    orderTips: 'Sort by based on last quarter data:',
    defaultOrder: 'Default',
    clickOrder: 'Consumer clicks',
    userClickOrder: 'DLitE3.x user clicks',
    productAmongOrder: 'Mostly used among consumer products',
    ingredientName: 'Ingredient Name',
    CASNumber: 'CAS Number',
    addToCompare: 'Add to Compare',
    alreadyAdded: 'Already Added',
    bevolClicks: 'Clicks in Bevol last quater',
    dlite3Clicks: 'Clicks in D’litE3X last quater',
    productCount: 'Products containing this INCI last quater',
    comparison: 'Comparison',
    view: 'View',
    QDName: 'QD Name',
    clicks: 'Clicks',
    relatedProduct: 'Related product from other companies',
    clicksTips: 'Top {current} amongst all ingredients in the {quarter}',
    ingredientsApplicationAnalysis: 'Ingredients application analysis',
    ingredientsApplicationAnalysisTips: 'Rate=Products containing this ingredient/All products by filter',
    brandGroup: 'Brand Group',
    brand: 'Brand',
    productsCount: 'Products Count',
    rate: 'Rate',
    year: 'Year',
    consumerProductsAnalysis: 'Consumer products analysis',
    top10ProductTitle: 'Top 10 product containing this ingredient by clicks during {current}',
    NOConsumerProducts: 'No. of consumer products(by Category) containing this ingredient in {current}',
    viewMore: 'View More Market Insights Related to This Ingredient',
    collapse: 'Collapse',
    relatedBASFProduct: 'BASF Product containing this ingredient',
    relatedFormulation: 'Related formulation containing this ingredient',
    moreInformation: 'More Information',
    ingredientCombination: 'Ingredient Combination Simulator',
    functionCombination: 'Function after combination',
    relatedIngredient: 'Related Ingredient',
    percentageCorrelationRatio: 'Percentage means the correlation ratio.',
    combinationRate: 'Combination Rate',
    relatedFormulations: 'Related Formulations containing both <span>{inci}</span> and <span>{selectInci}</span>',
    relatedFormulationTitle: 'Related Formulation'
  },
  myComparison: {
    myComparison: 'My Comparison',
    brand: {
      brand: 'Brand',
      tips: 'You can compare <span>5</span> Brands at most !',
      addBrand: 'Add Brand',
      basicInformation: 'Basic Information',
      brandOrigin: 'Brand Origin',
      brandPositioning: 'Brand Positioning',
      pricePositioning: 'Price Positioning',
      mainCategory: 'Main Category',
      mainClaim: 'Main Claim',
      productsQuantity: 'Products Quantity',
      clicks: 'Clicks',
      marketInformation: 'Market information',
      marketShare: 'Market Share',
      ranking: 'Ranking',
      segment: 'Segment',
      subSegment: 'Sub-Segment',
      clicksTips: 'The total number of clicks on all products of this brand from April 2018 to the present'
    },
    product: {
      product: 'Product',
      tips: 'You can compare <span>5</span> Products at most !',
      addProduct: 'Add Product',
      basicInformation: 'Basic information',
      category: 'Category',
      price: 'Price',
      capacity: 'Capacity',
      claims: 'Claims',
      functionIngredients: 'Function Ingredients',
      clicks: 'Clicks',
      commentScore: 'Comment score',
      comments: 'Comments',
      functionalIngredientList: 'Functional Ingredient List',
      consumerSkinType: 'Consumer Skin Type',
    },
    formulation: {
      formulation: 'Formulation',
      tips: 'You can compare <span>5</span> Formulation at most !',
      addFormulation: 'Add Formulation',
      category: 'Category',
      functionalClaim: 'Functional Claim',
      claims: 'Claims',
      BASFProduct: 'BASF Product',
      ingredientName: 'Ingredient Name',
      INCI: 'INCI',
      function: 'Function',
      hide: 'Hide',
      viewMore: 'View More',
      specifications: 'Specifications',
      performance: 'Performance',
      manufacturingProcess: 'Manufacturing Process'
    },
    inci: {
      INCI: 'INCI',
      tips: 'You can compare <span>5</span> Ingredient at most !',
      ingredientUsingTrend: 'Ingredient Using Trend',
      addIngredient: 'Add Ingredient',
      CASNumber: 'CAS Number',
      releaseLocations: 'Release Locations',
      productsQuantity: 'Products Quantity',
      clicks: 'Clicks',
      comments: 'Comments',
      function: 'Function',
      functionClaim: 'Functional Claim'
    }
  },
  myComments: {
    myComments: 'My Comments',
    allComments: 'All Comments',
    replies: 'Replies',
    date: 'Date',
    select: 'Select'
  },
  myFavorites: {
    myFavorites: 'My Favorites',
    consumerProducts: 'Consumer Products',
    brand: 'Brand',
    BASFProduct: 'BASF Product',
    formulation: 'Formulation',
    concept: 'Concept',
    trend: 'Trend',
    ingredient: 'Ingredient',
    cancelFavorite: 'Cancel favorite',
    collectionOfSuccess: 'Collection of success',
    canceledCollection: 'Canceled collection'
  },
  myRequest: {
    myRequest: 'My Request',
    documentRequest: 'Document Request',
    sampleRequest: 'Sample Request',
    module: 'Module',
    title: 'Title',
    PRDNumber: 'PRD Number/ID',
    content: 'Content',
    status: 'Status',
    requestTime: 'Request Time',
    approved: 'Approved',
    processing: 'Processing',
    denied: 'Denied',
    additionalRequests: 'Additional Requests',
    operator: 'Operator',
    tabName: 'Tab Name',
    operationTime: 'Operation Time',
    done: 'Done',
    doneOff: 'Done',
    sendFile: 'Send File',
    deny: 'Deny',
    reason: 'Reason',
    denyTips: 'Are you sure you want to reject?',
    doneTips: 'Are you sure you want to done?',
    reason1: 'Your identity verification failed, possibly due to using a public email or the company being unrecognized',
    reason2: 'This product is not sold in your region',
    reason3: 'This product is only sold to certain specific customers',
    upgradeRequest: 'Upgrade Request',
    upgradeRequestReason1: 'Please register using your company email. We usually do not apply for upgrades through a public email domain.',
    upgradeRequestReason2: 'The information you provided is too limited to be accurately identified. Please provide complete personal information.'
  },
  recentlyViewed: {
    recentlyViewed: 'Recently Viewed',
    showTips: 'Show content viewed in the past year'
  },
  deeplink: {
    tips: 'You can create a QR code, scan the QR code, jump to the module specified by the App',
    module: 'Module',
    creator: 'Creator',
    startDate: 'Start Date',
    endDate: 'End Date',
    addQRCode: 'Add QR Code',
    title: 'Title',
    createTime: 'Create Time',
    ccannedTimes: 'Scanned Times',
    downloadQRCode: 'Download QR Code',
    linkto: 'Link to',
    dataTitle: 'Data Title',
    versionTips: 'Due to technical limitations, only apps with v1.25.0 and above can achieve automatic redirect functionality.',
    appStoreDownload: 'App Store Download',
    remarks: 'Remarks',
    promotionActivity: 'Promotion Activity',
    utmSourceTips1: 'Please fill in English and Numbers ONLY, e.g. "202308CIDSEvent"',
    utmSourceTips2: 'Do not add any local language or symbols, such as spaces, "!", "@", etc.'
  },
  promotionActivity: {
    addPromotionActivity: 'Add Promotion Activity',
    link: 'Link',
    linkTips: 'Please enter the DlitE3X link you want to share'
  },
  role: {
    accessRole: 'Access Role',
    groupRole: 'Group Role',
    checkOne: 'Please check at least one permission',
    dontCheck: 'Please do not check permission'
  }
}
export default en



// WEBPACK FOOTER //
// ./src/lang/en.js